var map = {
	"./abandoned/mon_24.png": "7ebb",
	"./abandoned/mon_256.png": "6be3",
	"./abandoned/mon_64.png": "76e1",
	"./abandoned/mon_rotated.png": "d0e6",
	"./ovn/wh2_dlc09_tmb_the_sentinels/mon_24.png": "b2c3",
	"./ovn/wh2_dlc09_tmb_the_sentinels/mon_256.png": "2929",
	"./ovn/wh2_dlc09_tmb_the_sentinels/mon_64.png": "f324",
	"./ovn/wh2_dlc09_tmb_the_sentinels/mon_rotated.png": "2389",
	"./ovn/wh2_main_amz_amazons/mon_24.png": "3803",
	"./ovn/wh2_main_amz_amazons/mon_256.png": "39f9",
	"./ovn/wh2_main_amz_amazons/mon_64.png": "98ce",
	"./ovn/wh2_main_amz_amazons/mon_rotated.png": "34a5",
	"./ovn/wh2_main_arb_aswad_scythans/mon_24.png": "c78c",
	"./ovn/wh2_main_arb_aswad_scythans/mon_256.png": "18dc",
	"./ovn/wh2_main_arb_aswad_scythans/mon_64.png": "5cdb",
	"./ovn/wh2_main_arb_aswad_scythans/mon_rotated.png": "18c0",
	"./ovn/wh2_main_arb_caliphate_of_araby/mon_24.png": "5bf0",
	"./ovn/wh2_main_arb_caliphate_of_araby/mon_256.png": "1aca",
	"./ovn/wh2_main_arb_caliphate_of_araby/mon_64.png": "a670",
	"./ovn/wh2_main_arb_caliphate_of_araby/mon_rotated.png": "efee",
	"./ovn/wh2_main_arb_flaming_scimitar/mon_24.png": "97ac",
	"./ovn/wh2_main_arb_flaming_scimitar/mon_256.png": "d430",
	"./ovn/wh2_main_arb_flaming_scimitar/mon_64.png": "2997",
	"./ovn/wh2_main_arb_flaming_scimitar/mon_rotated.png": "8bd6",
	"./ovn/wh2_main_emp_grudgebringers/mon_24.png": "1e17",
	"./ovn/wh2_main_emp_grudgebringers/mon_256.png": "c0af",
	"./ovn/wh2_main_emp_grudgebringers/mon_64.png": "0cf2",
	"./ovn/wh2_main_emp_grudgebringers/mon_rotated.png": "b09a",
	"./ovn/wh2_main_emp_the_moot/mon_24.png": "d56c",
	"./ovn/wh2_main_emp_the_moot/mon_256.png": "2836",
	"./ovn/wh2_main_emp_the_moot/mon_64.png": "eb28",
	"./ovn/wh2_main_emp_the_moot/mon_rotated.png": "1306",
	"./ovn/wh2_main_nor_albion/mon_24.png": "b698",
	"./ovn/wh2_main_nor_albion/mon_256.png": "3c40",
	"./ovn/wh2_main_nor_albion/mon_64.png": "8afe",
	"./ovn/wh2_main_nor_albion/mon_rotated.png": "694c",
	"./ovn/wh2_main_nor_trollz/mon_24.png": "ff50",
	"./ovn/wh2_main_nor_trollz/mon_256.png": "fb35",
	"./ovn/wh2_main_nor_trollz/mon_64.png": "fa26",
	"./ovn/wh2_main_nor_trollz/mon_rotated.png": "ea44",
	"./ovn/wh2_main_ovn_chaos_dwarfs/mon_24.png": "09d0",
	"./ovn/wh2_main_ovn_chaos_dwarfs/mon_256.png": "631d",
	"./ovn/wh2_main_ovn_chaos_dwarfs/mon_64.png": "e147",
	"./ovn/wh2_main_ovn_chaos_dwarfs/mon_rotated.png": "adbc",
	"./ovn/wh2_main_wef_treeblood/mon_24.png": "38f3",
	"./ovn/wh2_main_wef_treeblood/mon_256.png": "ca04",
	"./ovn/wh2_main_wef_treeblood/mon_64.png": "c64b",
	"./ovn/wh2_main_wef_treeblood/mon_rotated.png": "05a0",
	"./ovn/wh_dlc08_nor_goromadny/mon_24.png": "95a9",
	"./ovn/wh_dlc08_nor_goromadny/mon_256.png": "13f8",
	"./ovn/wh_dlc08_nor_goromadny/mon_64.png": "da81",
	"./ovn/wh_dlc08_nor_goromadny/mon_rotated.png": "37b1",
	"./ovn/wh_dlc08_nor_naglfarlings/mon_24.png": "477d",
	"./ovn/wh_dlc08_nor_naglfarlings/mon_256.png": "b18d",
	"./ovn/wh_dlc08_nor_naglfarlings/mon_64.png": "7686",
	"./ovn/wh_dlc08_nor_naglfarlings/mon_rotated.png": "5756",
	"./ovn/wh_main_vmp_rival_sylvanian_vamps/mon_24.png": "80d5",
	"./ovn/wh_main_vmp_rival_sylvanian_vamps/mon_256.png": "6b95",
	"./ovn/wh_main_vmp_rival_sylvanian_vamps/mon_64.png": "921b",
	"./ovn/wh_main_vmp_rival_sylvanian_vamps/mon_rotated.png": "2c46",
	"./vanilla/faction_group_destruction/mon_64.png": "9fd3",
	"./vanilla/faction_group_order/mon_64.png": "a17b",
	"./vanilla/wh2_dlc09_rogue_black_creek_raiders/mon_24.png": "a605",
	"./vanilla/wh2_dlc09_rogue_black_creek_raiders/mon_256.png": "4791",
	"./vanilla/wh2_dlc09_rogue_black_creek_raiders/mon_64.png": "6a3f",
	"./vanilla/wh2_dlc09_rogue_black_creek_raiders/mon_rotated.png": "2a67",
	"./vanilla/wh2_dlc09_rogue_dwellers_of_zardok/mon_24.png": "550a",
	"./vanilla/wh2_dlc09_rogue_dwellers_of_zardok/mon_256.png": "0975",
	"./vanilla/wh2_dlc09_rogue_dwellers_of_zardok/mon_64.png": "9a6d",
	"./vanilla/wh2_dlc09_rogue_dwellers_of_zardok/mon_rotated.png": "84e8",
	"./vanilla/wh2_dlc09_rogue_eyes_of_the_jungle/mon_24.png": "5b5c",
	"./vanilla/wh2_dlc09_rogue_eyes_of_the_jungle/mon_256.png": "ee76",
	"./vanilla/wh2_dlc09_rogue_eyes_of_the_jungle/mon_64.png": "db74",
	"./vanilla/wh2_dlc09_rogue_eyes_of_the_jungle/mon_rotated.png": "9d5b",
	"./vanilla/wh2_dlc09_rogue_pilgrims_of_myrmidia/mon_24.png": "636f",
	"./vanilla/wh2_dlc09_rogue_pilgrims_of_myrmidia/mon_256.png": "5c62",
	"./vanilla/wh2_dlc09_rogue_pilgrims_of_myrmidia/mon_64.png": "805f",
	"./vanilla/wh2_dlc09_rogue_pilgrims_of_myrmidia/mon_rotated.png": "7e1e",
	"./vanilla/wh2_dlc09_skv_clan_rictus/mon_24.png": "a5a2",
	"./vanilla/wh2_dlc09_skv_clan_rictus/mon_256.png": "f1a1",
	"./vanilla/wh2_dlc09_skv_clan_rictus/mon_64.png": "063f",
	"./vanilla/wh2_dlc09_skv_clan_rictus/mon_rotated.png": "3df6",
	"./vanilla/wh2_dlc09_skv_clan_rictus_separatists/mon_24.png": "323a",
	"./vanilla/wh2_dlc09_skv_clan_rictus_separatists/mon_256.png": "c6d3",
	"./vanilla/wh2_dlc09_skv_clan_rictus_separatists/mon_64.png": "c87c",
	"./vanilla/wh2_dlc09_skv_clan_rictus_separatists/mon_rotated.png": "7c2a",
	"./vanilla/wh2_dlc09_tmb_dune_kingdoms/mon_24.png": "5628",
	"./vanilla/wh2_dlc09_tmb_dune_kingdoms/mon_256.png": "995c",
	"./vanilla/wh2_dlc09_tmb_dune_kingdoms/mon_64.png": "5d43",
	"./vanilla/wh2_dlc09_tmb_dune_kingdoms/mon_rotated.png": "c20f",
	"./vanilla/wh2_dlc09_tmb_exiles_of_nehek/mon_24.png": "10ca",
	"./vanilla/wh2_dlc09_tmb_exiles_of_nehek/mon_256.png": "ff67",
	"./vanilla/wh2_dlc09_tmb_exiles_of_nehek/mon_64.png": "e078",
	"./vanilla/wh2_dlc09_tmb_exiles_of_nehek/mon_rotated.png": "4934",
	"./vanilla/wh2_dlc09_tmb_followers_of_nagash/mon_24.png": "3c4a",
	"./vanilla/wh2_dlc09_tmb_followers_of_nagash/mon_256.png": "2110",
	"./vanilla/wh2_dlc09_tmb_followers_of_nagash/mon_64.png": "93db",
	"./vanilla/wh2_dlc09_tmb_followers_of_nagash/mon_rotated.png": "6fc5",
	"./vanilla/wh2_dlc09_tmb_khemri/mon_24.png": "8b50",
	"./vanilla/wh2_dlc09_tmb_khemri/mon_256.png": "6c19",
	"./vanilla/wh2_dlc09_tmb_khemri/mon_64.png": "ef4d",
	"./vanilla/wh2_dlc09_tmb_khemri/mon_rotated.png": "4ffb",
	"./vanilla/wh2_dlc09_tmb_lybaras/mon_24.png": "9e26",
	"./vanilla/wh2_dlc09_tmb_lybaras/mon_256.png": "453b",
	"./vanilla/wh2_dlc09_tmb_lybaras/mon_64.png": "8d80",
	"./vanilla/wh2_dlc09_tmb_lybaras/mon_rotated.png": "9206",
	"./vanilla/wh2_dlc09_tmb_numas/mon_24.png": "6d78",
	"./vanilla/wh2_dlc09_tmb_numas/mon_256.png": "7231",
	"./vanilla/wh2_dlc09_tmb_numas/mon_64.png": "2f32",
	"./vanilla/wh2_dlc09_tmb_numas/mon_rotated.png": "1662",
	"./vanilla/wh2_dlc09_tmb_rakaph_dynasty/mon_24.png": "6c2c",
	"./vanilla/wh2_dlc09_tmb_rakaph_dynasty/mon_256.png": "7a5f",
	"./vanilla/wh2_dlc09_tmb_rakaph_dynasty/mon_64.png": "a1a1",
	"./vanilla/wh2_dlc09_tmb_rakaph_dynasty/mon_rotated.png": "bce4",
	"./vanilla/wh2_dlc09_tmb_the_sentinels/mon_24.png": "a668",
	"./vanilla/wh2_dlc09_tmb_the_sentinels/mon_256.png": "05e4",
	"./vanilla/wh2_dlc09_tmb_the_sentinels/mon_64.png": "43c5",
	"./vanilla/wh2_dlc09_tmb_the_sentinels/mon_rotated.png": "8c91",
	"./vanilla/wh2_dlc09_tmb_tomb_kings_rebels/mon_24.png": "d3f9",
	"./vanilla/wh2_dlc09_tmb_tomb_kings_rebels/mon_256.png": "da6f",
	"./vanilla/wh2_dlc09_tmb_tomb_kings_rebels/mon_64.png": "8e3a",
	"./vanilla/wh2_dlc09_tmb_tomb_kings_rebels/mon_rotated.png": "c568",
	"./vanilla/wh2_dlc10_def_blood_voyage/mon_24.png": "e681",
	"./vanilla/wh2_dlc10_def_blood_voyage/mon_256.png": "528c",
	"./vanilla/wh2_dlc10_def_blood_voyage/mon_64.png": "3fc8",
	"./vanilla/wh2_dlc10_def_blood_voyage/mon_rotated.png": "f89b",
	"./vanilla/wh2_dlc11_cst_harpoon_the_sunken_land_corsairs/mon_24.png": "c99f",
	"./vanilla/wh2_dlc11_cst_harpoon_the_sunken_land_corsairs/mon_256.png": "ef90",
	"./vanilla/wh2_dlc11_cst_harpoon_the_sunken_land_corsairs/mon_64.png": "9e00",
	"./vanilla/wh2_dlc11_cst_harpoon_the_sunken_land_corsairs/mon_rotated.png": "7346",
	"./vanilla/wh2_dlc11_cst_noctilus/mon_24.png": "9730",
	"./vanilla/wh2_dlc11_cst_noctilus/mon_256.png": "e899",
	"./vanilla/wh2_dlc11_cst_noctilus/mon_64.png": "7e2a",
	"./vanilla/wh2_dlc11_cst_noctilus/mon_rotated.png": "329f",
	"./vanilla/wh2_dlc11_cst_noctilus_separatists/mon_24.png": "e472",
	"./vanilla/wh2_dlc11_cst_noctilus_separatists/mon_256.png": "8587",
	"./vanilla/wh2_dlc11_cst_noctilus_separatists/mon_64.png": "7740",
	"./vanilla/wh2_dlc11_cst_noctilus_separatists/mon_rotated.png": "4d4a",
	"./vanilla/wh2_dlc11_cst_pirates_of_sartosa/mon_24.png": "97d6",
	"./vanilla/wh2_dlc11_cst_pirates_of_sartosa/mon_256.png": "2017",
	"./vanilla/wh2_dlc11_cst_pirates_of_sartosa/mon_64.png": "3c9d",
	"./vanilla/wh2_dlc11_cst_pirates_of_sartosa/mon_rotated.png": "3fd9",
	"./vanilla/wh2_dlc11_cst_pirates_of_sartosa_separatists/mon_24.png": "bd78",
	"./vanilla/wh2_dlc11_cst_pirates_of_sartosa_separatists/mon_256.png": "9ba8",
	"./vanilla/wh2_dlc11_cst_pirates_of_sartosa_separatists/mon_64.png": "ee81",
	"./vanilla/wh2_dlc11_cst_pirates_of_sartosa_separatists/mon_rotated.png": "c1e5",
	"./vanilla/wh2_dlc11_cst_rogue_bleak_coast_buccaneers/mon_24.png": "9a3e",
	"./vanilla/wh2_dlc11_cst_rogue_bleak_coast_buccaneers/mon_256.png": "7894",
	"./vanilla/wh2_dlc11_cst_rogue_bleak_coast_buccaneers/mon_64.png": "eabe",
	"./vanilla/wh2_dlc11_cst_rogue_bleak_coast_buccaneers/mon_rotated.png": "6c23",
	"./vanilla/wh2_dlc11_cst_rogue_boyz_of_the_forbidden_coast/mon_24.png": "698e",
	"./vanilla/wh2_dlc11_cst_rogue_boyz_of_the_forbidden_coast/mon_256.png": "6d8b",
	"./vanilla/wh2_dlc11_cst_rogue_boyz_of_the_forbidden_coast/mon_64.png": "0c62",
	"./vanilla/wh2_dlc11_cst_rogue_boyz_of_the_forbidden_coast/mon_rotated.png": "0950",
	"./vanilla/wh2_dlc11_cst_rogue_freebooters_of_port_royale/mon_24.png": "f232",
	"./vanilla/wh2_dlc11_cst_rogue_freebooters_of_port_royale/mon_256.png": "411e",
	"./vanilla/wh2_dlc11_cst_rogue_freebooters_of_port_royale/mon_64.png": "4856",
	"./vanilla/wh2_dlc11_cst_rogue_freebooters_of_port_royale/mon_rotated.png": "e532",
	"./vanilla/wh2_dlc11_cst_rogue_grey_point_scuttlers/mon_24.png": "98d2",
	"./vanilla/wh2_dlc11_cst_rogue_grey_point_scuttlers/mon_256.png": "2d8b",
	"./vanilla/wh2_dlc11_cst_rogue_grey_point_scuttlers/mon_64.png": "cb8c",
	"./vanilla/wh2_dlc11_cst_rogue_grey_point_scuttlers/mon_rotated.png": "6944",
	"./vanilla/wh2_dlc11_cst_rogue_terrors_of_the_dark_straights/mon_24.png": "18f2",
	"./vanilla/wh2_dlc11_cst_rogue_terrors_of_the_dark_straights/mon_256.png": "0ce8",
	"./vanilla/wh2_dlc11_cst_rogue_terrors_of_the_dark_straights/mon_64.png": "b43d",
	"./vanilla/wh2_dlc11_cst_rogue_terrors_of_the_dark_straights/mon_rotated.png": "5a8c",
	"./vanilla/wh2_dlc11_cst_rogue_the_churning_gulf_raiders/mon_24.png": "1b03",
	"./vanilla/wh2_dlc11_cst_rogue_the_churning_gulf_raiders/mon_256.png": "52ab",
	"./vanilla/wh2_dlc11_cst_rogue_the_churning_gulf_raiders/mon_64.png": "9e6c",
	"./vanilla/wh2_dlc11_cst_rogue_the_churning_gulf_raiders/mon_rotated.png": "9033",
	"./vanilla/wh2_dlc11_cst_rogue_tyrants_of_the_black_ocean/mon_24.png": "0e36",
	"./vanilla/wh2_dlc11_cst_rogue_tyrants_of_the_black_ocean/mon_256.png": "2857",
	"./vanilla/wh2_dlc11_cst_rogue_tyrants_of_the_black_ocean/mon_64.png": "ce10",
	"./vanilla/wh2_dlc11_cst_rogue_tyrants_of_the_black_ocean/mon_rotated.png": "75a8",
	"./vanilla/wh2_dlc11_cst_shanty_dragon_spine_privateers/mon_24.png": "9cab",
	"./vanilla/wh2_dlc11_cst_shanty_dragon_spine_privateers/mon_256.png": "aef3",
	"./vanilla/wh2_dlc11_cst_shanty_dragon_spine_privateers/mon_64.png": "f060",
	"./vanilla/wh2_dlc11_cst_shanty_dragon_spine_privateers/mon_rotated.png": "9f25",
	"./vanilla/wh2_dlc11_cst_shanty_middle_sea_brigands/mon_24.png": "6afa",
	"./vanilla/wh2_dlc11_cst_shanty_middle_sea_brigands/mon_256.png": "2e1b",
	"./vanilla/wh2_dlc11_cst_shanty_middle_sea_brigands/mon_64.png": "5160",
	"./vanilla/wh2_dlc11_cst_shanty_middle_sea_brigands/mon_rotated.png": "7335",
	"./vanilla/wh2_dlc11_cst_shanty_shark_straight_seadogs/mon_24.png": "8b3c",
	"./vanilla/wh2_dlc11_cst_shanty_shark_straight_seadogs/mon_256.png": "9f72",
	"./vanilla/wh2_dlc11_cst_shanty_shark_straight_seadogs/mon_64.png": "2c30",
	"./vanilla/wh2_dlc11_cst_shanty_shark_straight_seadogs/mon_rotated.png": "aaed",
	"./vanilla/wh2_dlc11_cst_the_drowned/mon_24.png": "f38fe",
	"./vanilla/wh2_dlc11_cst_the_drowned/mon_256.png": "6a52",
	"./vanilla/wh2_dlc11_cst_the_drowned/mon_64.png": "3d7e",
	"./vanilla/wh2_dlc11_cst_the_drowned/mon_rotated.png": "3839",
	"./vanilla/wh2_dlc11_cst_the_drowned_separatists/mon_24.png": "3002",
	"./vanilla/wh2_dlc11_cst_the_drowned_separatists/mon_256.png": "52fe",
	"./vanilla/wh2_dlc11_cst_the_drowned_separatists/mon_64.png": "02e7",
	"./vanilla/wh2_dlc11_cst_the_drowned_separatists/mon_rotated.png": "0128",
	"./vanilla/wh2_dlc11_cst_vampire_coast/mon_24.png": "0c41",
	"./vanilla/wh2_dlc11_cst_vampire_coast/mon_256.png": "1ef0",
	"./vanilla/wh2_dlc11_cst_vampire_coast/mon_64.png": "3b87",
	"./vanilla/wh2_dlc11_cst_vampire_coast/mon_rotated.png": "4575",
	"./vanilla/wh2_dlc11_cst_vampire_coast_mutineers/mon_24.png": "e699",
	"./vanilla/wh2_dlc11_cst_vampire_coast_mutineers/mon_256.png": "14f3",
	"./vanilla/wh2_dlc11_cst_vampire_coast_mutineers/mon_64.png": "eadd",
	"./vanilla/wh2_dlc11_cst_vampire_coast_mutineers/mon_rotated.png": "c012",
	"./vanilla/wh2_dlc11_cst_vampire_coast_rebels/mon_24.png": "603b",
	"./vanilla/wh2_dlc11_cst_vampire_coast_rebels/mon_256.png": "c796",
	"./vanilla/wh2_dlc11_cst_vampire_coast_rebels/mon_64.png": "6293",
	"./vanilla/wh2_dlc11_cst_vampire_coast_rebels/mon_rotated.png": "b1de",
	"./vanilla/wh2_dlc11_cst_vampire_coast_separatists/mon_24.png": "566c",
	"./vanilla/wh2_dlc11_cst_vampire_coast_separatists/mon_256.png": "4943",
	"./vanilla/wh2_dlc11_cst_vampire_coast_separatists/mon_64.png": "f95c",
	"./vanilla/wh2_dlc11_cst_vampire_coast_separatists/mon_rotated.png": "cd34",
	"./vanilla/wh2_dlc11_def_the_blessed_dread/mon_24.png": "62bd",
	"./vanilla/wh2_dlc11_def_the_blessed_dread/mon_256.png": "a864",
	"./vanilla/wh2_dlc11_def_the_blessed_dread/mon_64.png": "c695",
	"./vanilla/wh2_dlc11_def_the_blessed_dread/mon_rotated.png": "d90f",
	"./vanilla/wh2_dlc11_def_the_blessed_dread_separatists/mon_24.png": "9dbc",
	"./vanilla/wh2_dlc11_def_the_blessed_dread_separatists/mon_256.png": "f1ee",
	"./vanilla/wh2_dlc11_def_the_blessed_dread_separatists/mon_64.png": "95e6",
	"./vanilla/wh2_dlc11_def_the_blessed_dread_separatists/mon_rotated.png": "b722",
	"./vanilla/wh2_dlc11_vmp_the_barrow_legion/mon_24.png": "2120",
	"./vanilla/wh2_dlc11_vmp_the_barrow_legion/mon_256.png": "2f1c",
	"./vanilla/wh2_dlc11_vmp_the_barrow_legion/mon_64.png": "73d7",
	"./vanilla/wh2_dlc11_vmp_the_barrow_legion/mon_rotated.png": "c0d6",
	"./vanilla/wh2_dlc12_lzd_cult_of_sotek/mon_24.png": "015a",
	"./vanilla/wh2_dlc12_lzd_cult_of_sotek/mon_256.png": "0a22",
	"./vanilla/wh2_dlc12_lzd_cult_of_sotek/mon_64.png": "a30a",
	"./vanilla/wh2_dlc12_lzd_cult_of_sotek/mon_rotated.png": "97ba",
	"./vanilla/wh2_dlc12_skv_clan_fester/mon_24.png": "68c2",
	"./vanilla/wh2_dlc12_skv_clan_fester/mon_256.png": "e315",
	"./vanilla/wh2_dlc12_skv_clan_fester/mon_64.png": "d6fc",
	"./vanilla/wh2_dlc12_skv_clan_fester/mon_rotated.png": "f2d7",
	"./vanilla/wh2_dlc12_skv_clan_mange/mon_24.png": "2b2b",
	"./vanilla/wh2_dlc12_skv_clan_mange/mon_256.png": "89b5",
	"./vanilla/wh2_dlc12_skv_clan_mange/mon_64.png": "a82e",
	"./vanilla/wh2_dlc12_skv_clan_mange/mon_rotated.png": "dc7b",
	"./vanilla/wh2_dlc13_emp_golden_order/mon_24.png": "84ef",
	"./vanilla/wh2_dlc13_emp_golden_order/mon_256.png": "20e1",
	"./vanilla/wh2_dlc13_emp_golden_order/mon_64.png": "248f",
	"./vanilla/wh2_dlc13_emp_golden_order/mon_rotated.png": "2a6c",
	"./vanilla/wh2_dlc13_emp_the_huntmarshals_expedition/mon_24.png": "f5c9",
	"./vanilla/wh2_dlc13_emp_the_huntmarshals_expedition/mon_256.png": "8cbf",
	"./vanilla/wh2_dlc13_emp_the_huntmarshals_expedition/mon_64.png": "38c2",
	"./vanilla/wh2_dlc13_emp_the_huntmarshals_expedition/mon_rotated.png": "74a6",
	"./vanilla/wh2_dlc13_lzd_avengers/mon_24.png": "147a",
	"./vanilla/wh2_dlc13_lzd_avengers/mon_256.png": "fe56",
	"./vanilla/wh2_dlc13_lzd_avengers/mon_64.png": "878b",
	"./vanilla/wh2_dlc13_lzd_avengers/mon_rotated.png": "e9a8",
	"./vanilla/wh2_dlc13_lzd_defenders_of_the_great_plan/mon_24.png": "114f",
	"./vanilla/wh2_dlc13_lzd_defenders_of_the_great_plan/mon_256.png": "5a82",
	"./vanilla/wh2_dlc13_lzd_defenders_of_the_great_plan/mon_64.png": "8f1e",
	"./vanilla/wh2_dlc13_lzd_defenders_of_the_great_plan/mon_rotated.png": "562d",
	"./vanilla/wh2_dlc13_lzd_spirits_of_the_jungle/mon_24.png": "c4af",
	"./vanilla/wh2_dlc13_lzd_spirits_of_the_jungle/mon_256.png": "badb",
	"./vanilla/wh2_dlc13_lzd_spirits_of_the_jungle/mon_64.png": "5661",
	"./vanilla/wh2_dlc13_lzd_spirits_of_the_jungle/mon_rotated.png": "0104",
	"./vanilla/wh2_dlc13_wef_laurelorn_forest/mon_24.png": "b351",
	"./vanilla/wh2_dlc13_wef_laurelorn_forest/mon_256.png": "5ebb",
	"./vanilla/wh2_dlc13_wef_laurelorn_forest/mon_64.png": "242c",
	"./vanilla/wh2_dlc13_wef_laurelorn_forest/mon_rotated.png": "f3ce",
	"./vanilla/wh2_dlc14_grn_red_cloud/mon_24.png": "4f965",
	"./vanilla/wh2_dlc14_grn_red_cloud/mon_256.png": "31f6",
	"./vanilla/wh2_dlc14_grn_red_cloud/mon_64.png": "ff66",
	"./vanilla/wh2_dlc14_grn_red_cloud/mon_rotated.png": "6f81",
	"./vanilla/wh2_dlc14_lzd_itz_itza_tribe/mon_24.png": "3272",
	"./vanilla/wh2_dlc14_lzd_itz_itza_tribe/mon_256.png": "9822",
	"./vanilla/wh2_dlc14_lzd_itz_itza_tribe/mon_64.png": "1d69",
	"./vanilla/wh2_dlc14_lzd_itz_itza_tribe/mon_rotated.png": "0048",
	"./vanilla/wh2_dlc14_skv_rictus_clan_nest/mon_24.png": "ae36",
	"./vanilla/wh2_dlc14_skv_rictus_clan_nest/mon_256.png": "f835",
	"./vanilla/wh2_dlc14_skv_rictus_clan_nest/mon_64.png": "5461",
	"./vanilla/wh2_dlc14_skv_rictus_clan_nest/mon_rotated.png": "c8fe",
	"./vanilla/wh2_dlc15_dwf_clan_helhein/mon_24.png": "fa47",
	"./vanilla/wh2_dlc15_dwf_clan_helhein/mon_256.png": "92fc",
	"./vanilla/wh2_dlc15_dwf_clan_helhein/mon_64.png": "d2cf",
	"./vanilla/wh2_dlc15_dwf_clan_helhein/mon_rotated.png": "62b6",
	"./vanilla/wh2_dlc15_grn_bonerattlaz/mon_24.png": "05e6",
	"./vanilla/wh2_dlc15_grn_bonerattlaz/mon_256.png": "a85a",
	"./vanilla/wh2_dlc15_grn_bonerattlaz/mon_64.png": "dba7",
	"./vanilla/wh2_dlc15_grn_bonerattlaz/mon_rotated.png": "321f",
	"./vanilla/wh2_dlc15_grn_broken_axe/mon_24.png": "cc7a",
	"./vanilla/wh2_dlc15_grn_broken_axe/mon_256.png": "e924",
	"./vanilla/wh2_dlc15_grn_broken_axe/mon_64.png": "7a47",
	"./vanilla/wh2_dlc15_grn_broken_axe/mon_rotated.png": "08c5",
	"./vanilla/wh2_dlc15_grn_skull_crag/mon_24.png": "335d",
	"./vanilla/wh2_dlc15_grn_skull_crag/mon_256.png": "8d19",
	"./vanilla/wh2_dlc15_grn_skull_crag/mon_64.png": "bbdd",
	"./vanilla/wh2_dlc15_grn_skull_crag/mon_rotated.png": "7713",
	"./vanilla/wh2_dlc15_hef_imrik/mon_24.png": "6a56",
	"./vanilla/wh2_dlc15_hef_imrik/mon_256.png": "7d84",
	"./vanilla/wh2_dlc15_hef_imrik/mon_64.png": "e872",
	"./vanilla/wh2_dlc15_hef_imrik/mon_rotated.png": "2da8",
	"./vanilla/wh2_dlc15_skv_clan_ferrik/mon_24.png": "770f",
	"./vanilla/wh2_dlc15_skv_clan_ferrik/mon_256.png": "6ffe",
	"./vanilla/wh2_dlc15_skv_clan_ferrik/mon_64.png": "0dd4",
	"./vanilla/wh2_dlc15_skv_clan_ferrik/mon_rotated.png": "7161",
	"./vanilla/wh2_dlc15_skv_clan_kreepus/mon_24.png": "dd6a",
	"./vanilla/wh2_dlc15_skv_clan_kreepus/mon_256.png": "c0aa",
	"./vanilla/wh2_dlc15_skv_clan_kreepus/mon_64.png": "f888",
	"./vanilla/wh2_dlc15_skv_clan_kreepus/mon_rotated.png": "1c04",
	"./vanilla/wh2_dlc15_skv_clan_volkn/mon_24.png": "d390",
	"./vanilla/wh2_dlc15_skv_clan_volkn/mon_256.png": "04ec",
	"./vanilla/wh2_dlc15_skv_clan_volkn/mon_64.png": "b8e9",
	"./vanilla/wh2_dlc15_skv_clan_volkn/mon_rotated.png": "b2a0",
	"./vanilla/wh2_main_brt_knights_of_origo/mon_24.png": "ecde",
	"./vanilla/wh2_main_brt_knights_of_origo/mon_256.png": "b3c2",
	"./vanilla/wh2_main_brt_knights_of_origo/mon_64.png": "acce",
	"./vanilla/wh2_main_brt_knights_of_origo/mon_rotated.png": "686a",
	"./vanilla/wh2_main_brt_knights_of_the_flame/mon_24.png": "d7ce",
	"./vanilla/wh2_main_brt_knights_of_the_flame/mon_256.png": "6044",
	"./vanilla/wh2_main_brt_knights_of_the_flame/mon_64.png": "940f",
	"./vanilla/wh2_main_brt_knights_of_the_flame/mon_rotated.png": "3ed8",
	"./vanilla/wh2_main_brt_thegans_crusaders/mon_24.png": "9a9d",
	"./vanilla/wh2_main_brt_thegans_crusaders/mon_256.png": "841a",
	"./vanilla/wh2_main_brt_thegans_crusaders/mon_64.png": "5166",
	"./vanilla/wh2_main_brt_thegans_crusaders/mon_rotated.png": "38f1",
	"./vanilla/wh2_main_bst_blooded_axe/mon_24.png": "c300",
	"./vanilla/wh2_main_bst_blooded_axe/mon_256.png": "a3cd",
	"./vanilla/wh2_main_bst_blooded_axe/mon_64.png": "2e76",
	"./vanilla/wh2_main_bst_blooded_axe/mon_rotated.png": "805c",
	"./vanilla/wh2_main_bst_manblight/mon_24.png": "6397",
	"./vanilla/wh2_main_bst_manblight/mon_256.png": "bbe9",
	"./vanilla/wh2_main_bst_manblight/mon_64.png": "2edf",
	"./vanilla/wh2_main_bst_manblight/mon_rotated.png": "12a6",
	"./vanilla/wh2_main_bst_stone_horn/mon_24.png": "3bcd",
	"./vanilla/wh2_main_bst_stone_horn/mon_256.png": "bba8",
	"./vanilla/wh2_main_bst_stone_horn/mon_64.png": "8187",
	"./vanilla/wh2_main_bst_stone_horn/mon_rotated.png": "1a5c",
	"./vanilla/wh2_main_chs_followers_of_chaos/mon_24.png": "f040",
	"./vanilla/wh2_main_chs_followers_of_chaos/mon_256.png": "def0",
	"./vanilla/wh2_main_chs_followers_of_chaos/mon_64.png": "b707",
	"./vanilla/wh2_main_chs_followers_of_chaos/mon_rotated.png": "aeef",
	"./vanilla/wh2_main_chs_puppets_of_chaos/mon_24.png": "e4cc",
	"./vanilla/wh2_main_chs_puppets_of_chaos/mon_256.png": "5fa9",
	"./vanilla/wh2_main_chs_puppets_of_chaos/mon_64.png": "910f",
	"./vanilla/wh2_main_chs_puppets_of_chaos/mon_rotated.png": "02fd",
	"./vanilla/wh2_main_chs_servants_to_chaos/mon_24.png": "8e5a",
	"./vanilla/wh2_main_chs_servants_to_chaos/mon_256.png": "5878",
	"./vanilla/wh2_main_chs_servants_to_chaos/mon_64.png": "bcbb",
	"./vanilla/wh2_main_chs_servants_to_chaos/mon_rotated.png": "f5b5",
	"./vanilla/wh2_main_chs_vessels_of_chaos/mon_24.png": "97f3",
	"./vanilla/wh2_main_chs_vessels_of_chaos/mon_256.png": "7a49",
	"./vanilla/wh2_main_chs_vessels_of_chaos/mon_64.png": "0801",
	"./vanilla/wh2_main_chs_vessels_of_chaos/mon_rotated.png": "e98f",
	"./vanilla/wh2_main_def_bleak_holds/mon_24.png": "676b",
	"./vanilla/wh2_main_def_bleak_holds/mon_256.png": "9bfd",
	"./vanilla/wh2_main_def_bleak_holds/mon_64.png": "fa7f",
	"./vanilla/wh2_main_def_bleak_holds/mon_rotated.png": "7ab7",
	"./vanilla/wh2_main_def_blood_hall_coven/mon_24.png": "33b4",
	"./vanilla/wh2_main_def_blood_hall_coven/mon_256.png": "dfdd",
	"./vanilla/wh2_main_def_blood_hall_coven/mon_64.png": "4ca3",
	"./vanilla/wh2_main_def_blood_hall_coven/mon_rotated.png": "3654",
	"./vanilla/wh2_main_def_clar_karond/mon_24.png": "f833",
	"./vanilla/wh2_main_def_clar_karond/mon_256.png": "11f4",
	"./vanilla/wh2_main_def_clar_karond/mon_64.png": "791b",
	"./vanilla/wh2_main_def_clar_karond/mon_rotated.png": "8b4e",
	"./vanilla/wh2_main_def_cult_of_excess/mon_24.png": "5ea2",
	"./vanilla/wh2_main_def_cult_of_excess/mon_256.png": "53eb",
	"./vanilla/wh2_main_def_cult_of_excess/mon_64.png": "f11b",
	"./vanilla/wh2_main_def_cult_of_excess/mon_rotated.png": "edfe",
	"./vanilla/wh2_main_def_cult_of_pleasure/mon_24.png": "d93f",
	"./vanilla/wh2_main_def_cult_of_pleasure/mon_256.png": "dfec",
	"./vanilla/wh2_main_def_cult_of_pleasure/mon_64.png": "7568",
	"./vanilla/wh2_main_def_cult_of_pleasure/mon_rotated.png": "9a9a",
	"./vanilla/wh2_main_def_cult_of_pleasure_separatists/mon_24.png": "efa1",
	"./vanilla/wh2_main_def_cult_of_pleasure_separatists/mon_256.png": "90f8",
	"./vanilla/wh2_main_def_cult_of_pleasure_separatists/mon_64.png": "9915",
	"./vanilla/wh2_main_def_cult_of_pleasure_separatists/mon_rotated.png": "0993",
	"./vanilla/wh2_main_def_dark_elves_rebels/mon_24.png": "1109",
	"./vanilla/wh2_main_def_dark_elves_rebels/mon_256.png": "a9d8",
	"./vanilla/wh2_main_def_dark_elves_rebels/mon_64.png": "c386",
	"./vanilla/wh2_main_def_dark_elves_rebels/mon_rotated.png": "1625",
	"./vanilla/wh2_main_def_deadwood_sentinels/mon_24.png": "d0d2",
	"./vanilla/wh2_main_def_deadwood_sentinels/mon_256.png": "5620",
	"./vanilla/wh2_main_def_deadwood_sentinels/mon_64.png": "78a7",
	"./vanilla/wh2_main_def_deadwood_sentinels/mon_rotated.png": "49d4",
	"./vanilla/wh2_main_def_drackla_coven/mon_24.png": "dcd3",
	"./vanilla/wh2_main_def_drackla_coven/mon_256.png": "7e36",
	"./vanilla/wh2_main_def_drackla_coven/mon_64.png": "17a7",
	"./vanilla/wh2_main_def_drackla_coven/mon_rotated.png": "876d",
	"./vanilla/wh2_main_def_ghrond/mon_24.png": "0c55",
	"./vanilla/wh2_main_def_ghrond/mon_256.png": "1c51",
	"./vanilla/wh2_main_def_ghrond/mon_64.png": "044e",
	"./vanilla/wh2_main_def_ghrond/mon_rotated.png": "9b7e",
	"./vanilla/wh2_main_def_hag_graef/mon_24.png": "e842",
	"./vanilla/wh2_main_def_hag_graef/mon_256.png": "b086",
	"./vanilla/wh2_main_def_hag_graef/mon_64.png": "3714",
	"./vanilla/wh2_main_def_hag_graef/mon_rotated.png": "61a1",
	"./vanilla/wh2_main_def_hag_graef_separatists/mon_24.png": "3235",
	"./vanilla/wh2_main_def_hag_graef_separatists/mon_256.png": "40cb",
	"./vanilla/wh2_main_def_hag_graef_separatists/mon_64.png": "c039",
	"./vanilla/wh2_main_def_hag_graef_separatists/mon_rotated.png": "7396",
	"./vanilla/wh2_main_def_har_ganeth/mon_24.png": "99ba",
	"./vanilla/wh2_main_def_har_ganeth/mon_256.png": "9fa6",
	"./vanilla/wh2_main_def_har_ganeth/mon_64.png": "f732",
	"./vanilla/wh2_main_def_har_ganeth/mon_rotated.png": "f138",
	"./vanilla/wh2_main_def_har_ganeth_separatists/mon_24.png": "0d39",
	"./vanilla/wh2_main_def_har_ganeth_separatists/mon_256.png": "ddf3",
	"./vanilla/wh2_main_def_har_ganeth_separatists/mon_64.png": "0702",
	"./vanilla/wh2_main_def_har_ganeth_separatists/mon_rotated.png": "76f1",
	"./vanilla/wh2_main_def_karond_kar/mon_24.png": "a1be",
	"./vanilla/wh2_main_def_karond_kar/mon_256.png": "8460",
	"./vanilla/wh2_main_def_karond_kar/mon_64.png": "20cb",
	"./vanilla/wh2_main_def_karond_kar/mon_rotated.png": "879e",
	"./vanilla/wh2_main_def_naggarond/mon_24.png": "12fa",
	"./vanilla/wh2_main_def_naggarond/mon_256.png": "410e",
	"./vanilla/wh2_main_def_naggarond/mon_64.png": "e2f7",
	"./vanilla/wh2_main_def_naggarond/mon_rotated.png": "da74",
	"./vanilla/wh2_main_def_naggarond_intervention/mon_24.png": "c53a",
	"./vanilla/wh2_main_def_naggarond_intervention/mon_256.png": "980b",
	"./vanilla/wh2_main_def_naggarond_intervention/mon_64.png": "1ae6",
	"./vanilla/wh2_main_def_naggarond_intervention/mon_rotated.png": "a014",
	"./vanilla/wh2_main_def_naggarond_separatists/mon_24.png": "efae",
	"./vanilla/wh2_main_def_naggarond_separatists/mon_256.png": "b0bc",
	"./vanilla/wh2_main_def_naggarond_separatists/mon_64.png": "a9b9",
	"./vanilla/wh2_main_def_naggarond_separatists/mon_rotated.png": "c0f7",
	"./vanilla/wh2_main_def_scourge_of_khaine/mon_24.png": "4d11",
	"./vanilla/wh2_main_def_scourge_of_khaine/mon_256.png": "5f1a",
	"./vanilla/wh2_main_def_scourge_of_khaine/mon_64.png": "2dcb",
	"./vanilla/wh2_main_def_scourge_of_khaine/mon_rotated.png": "1e2f",
	"./vanilla/wh2_main_def_ssildra_tor/mon_24.png": "c893",
	"./vanilla/wh2_main_def_ssildra_tor/mon_256.png": "192a",
	"./vanilla/wh2_main_def_ssildra_tor/mon_64.png": "cff3",
	"./vanilla/wh2_main_def_ssildra_tor/mon_rotated.png": "0d5b",
	"./vanilla/wh2_main_def_the_forgebound/mon_24.png": "3a9f",
	"./vanilla/wh2_main_def_the_forgebound/mon_256.png": "997d",
	"./vanilla/wh2_main_def_the_forgebound/mon_64.png": "6601",
	"./vanilla/wh2_main_def_the_forgebound/mon_rotated.png": "ed13",
	"./vanilla/wh2_main_dwf_greybeards_prospectors/mon_24.png": "7d32",
	"./vanilla/wh2_main_dwf_greybeards_prospectors/mon_256.png": "fa28",
	"./vanilla/wh2_main_dwf_greybeards_prospectors/mon_64.png": "846f",
	"./vanilla/wh2_main_dwf_greybeards_prospectors/mon_rotated.png": "40c9",
	"./vanilla/wh2_main_dwf_karak_zorn/mon_24.png": "71c3",
	"./vanilla/wh2_main_dwf_karak_zorn/mon_256.png": "6974",
	"./vanilla/wh2_main_dwf_karak_zorn/mon_64.png": "21fe",
	"./vanilla/wh2_main_dwf_karak_zorn/mon_rotated.png": "2db2",
	"./vanilla/wh2_main_dwf_spine_of_sotek_dwarfs/mon_24.png": "d031",
	"./vanilla/wh2_main_dwf_spine_of_sotek_dwarfs/mon_256.png": "3951",
	"./vanilla/wh2_main_dwf_spine_of_sotek_dwarfs/mon_64.png": "8def",
	"./vanilla/wh2_main_dwf_spine_of_sotek_dwarfs/mon_rotated.png": "e53f",
	"./vanilla/wh2_main_emp_new_world_colonies/mon_24.png": "4631",
	"./vanilla/wh2_main_emp_new_world_colonies/mon_256.png": "d2b4",
	"./vanilla/wh2_main_emp_new_world_colonies/mon_64.png": "e2ba",
	"./vanilla/wh2_main_emp_new_world_colonies/mon_rotated.png": "1f27",
	"./vanilla/wh2_main_emp_pirates_of_sartosa/mon_24.png": "a329",
	"./vanilla/wh2_main_emp_pirates_of_sartosa/mon_256.png": "5db0",
	"./vanilla/wh2_main_emp_pirates_of_sartosa/mon_64.png": "4da0",
	"./vanilla/wh2_main_emp_pirates_of_sartosa/mon_rotated.png": "deeb",
	"./vanilla/wh2_main_emp_sudenburg/mon_24.png": "0809",
	"./vanilla/wh2_main_emp_sudenburg/mon_256.png": "a377",
	"./vanilla/wh2_main_emp_sudenburg/mon_64.png": "f0cf",
	"./vanilla/wh2_main_emp_sudenburg/mon_rotated.png": "b027",
	"./vanilla/wh2_main_grn_arachnos/mon_24.png": "707b",
	"./vanilla/wh2_main_grn_arachnos/mon_256.png": "725c",
	"./vanilla/wh2_main_grn_arachnos/mon_64.png": "4cb9",
	"./vanilla/wh2_main_grn_arachnos/mon_rotated.png": "401a",
	"./vanilla/wh2_main_grn_blue_vipers/mon_24.png": "a7d5",
	"./vanilla/wh2_main_grn_blue_vipers/mon_256.png": "20c8",
	"./vanilla/wh2_main_grn_blue_vipers/mon_64.png": "7fd4",
	"./vanilla/wh2_main_grn_blue_vipers/mon_rotated.png": "50cc",
	"./vanilla/wh2_main_hef_avelorn/mon_24.png": "f5f1",
	"./vanilla/wh2_main_hef_avelorn/mon_256.png": "d247",
	"./vanilla/wh2_main_hef_avelorn/mon_64.png": "2bf1",
	"./vanilla/wh2_main_hef_avelorn/mon_rotated.png": "ab58",
	"./vanilla/wh2_main_hef_caledor/mon_24.png": "1fd3",
	"./vanilla/wh2_main_hef_caledor/mon_256.png": "72a0",
	"./vanilla/wh2_main_hef_caledor/mon_64.png": "6e02",
	"./vanilla/wh2_main_hef_caledor/mon_rotated.png": "626e",
	"./vanilla/wh2_main_hef_chrace/mon_24.png": "1a33",
	"./vanilla/wh2_main_hef_chrace/mon_256.png": "7a7b",
	"./vanilla/wh2_main_hef_chrace/mon_64.png": "f45b",
	"./vanilla/wh2_main_hef_chrace/mon_rotated.png": "2a92",
	"./vanilla/wh2_main_hef_citadel_of_dusk/mon_24.png": "391a",
	"./vanilla/wh2_main_hef_citadel_of_dusk/mon_256.png": "e922",
	"./vanilla/wh2_main_hef_citadel_of_dusk/mon_64.png": "f2bf",
	"./vanilla/wh2_main_hef_citadel_of_dusk/mon_rotated.png": "9202",
	"./vanilla/wh2_main_hef_cothique/mon_24.png": "877c",
	"./vanilla/wh2_main_hef_cothique/mon_256.png": "b3a7",
	"./vanilla/wh2_main_hef_cothique/mon_64.png": "1ffa",
	"./vanilla/wh2_main_hef_cothique/mon_rotated.png": "21f0",
	"./vanilla/wh2_main_hef_eataine/mon_24.png": "b833",
	"./vanilla/wh2_main_hef_eataine/mon_256.png": "66d3",
	"./vanilla/wh2_main_hef_eataine/mon_64.png": "1ad6",
	"./vanilla/wh2_main_hef_eataine/mon_rotated.png": "13a3",
	"./vanilla/wh2_main_hef_ellyrion/mon_24.png": "be37",
	"./vanilla/wh2_main_hef_ellyrion/mon_256.png": "e657",
	"./vanilla/wh2_main_hef_ellyrion/mon_64.png": "f294",
	"./vanilla/wh2_main_hef_ellyrion/mon_rotated.png": "a685",
	"./vanilla/wh2_main_hef_fortress_of_dawn/mon_24.png": "dfae",
	"./vanilla/wh2_main_hef_fortress_of_dawn/mon_256.png": "c96c",
	"./vanilla/wh2_main_hef_fortress_of_dawn/mon_64.png": "d6e2",
	"./vanilla/wh2_main_hef_fortress_of_dawn/mon_rotated.png": "ec90",
	"./vanilla/wh2_main_hef_high_elves_rebels/mon_24.png": "0935",
	"./vanilla/wh2_main_hef_high_elves_rebels/mon_256.png": "5117",
	"./vanilla/wh2_main_hef_high_elves_rebels/mon_64.png": "4791c",
	"./vanilla/wh2_main_hef_high_elves_rebels/mon_rotated.png": "8aac",
	"./vanilla/wh2_main_hef_lothern/mon_24.png": "5106",
	"./vanilla/wh2_main_hef_lothern/mon_256.png": "b145",
	"./vanilla/wh2_main_hef_lothern/mon_64.png": "df14",
	"./vanilla/wh2_main_hef_lothern/mon_rotated.png": "fb73",
	"./vanilla/wh2_main_hef_nagarythe/mon_24.png": "3a2e",
	"./vanilla/wh2_main_hef_nagarythe/mon_256.png": "53da",
	"./vanilla/wh2_main_hef_nagarythe/mon_64.png": "ccfb",
	"./vanilla/wh2_main_hef_nagarythe/mon_rotated.png": "09fa",
	"./vanilla/wh2_main_hef_order_of_loremasters/mon_24.png": "15f1",
	"./vanilla/wh2_main_hef_order_of_loremasters/mon_256.png": "48ba",
	"./vanilla/wh2_main_hef_order_of_loremasters/mon_64.png": "8f13",
	"./vanilla/wh2_main_hef_order_of_loremasters/mon_rotated.png": "061a",
	"./vanilla/wh2_main_hef_saphery/mon_24.png": "8087",
	"./vanilla/wh2_main_hef_saphery/mon_256.png": "d366",
	"./vanilla/wh2_main_hef_saphery/mon_64.png": "518e",
	"./vanilla/wh2_main_hef_saphery/mon_rotated.png": "c9e8",
	"./vanilla/wh2_main_hef_tiranoc/mon_24.png": "6fb4",
	"./vanilla/wh2_main_hef_tiranoc/mon_256.png": "5c89",
	"./vanilla/wh2_main_hef_tiranoc/mon_64.png": "1412",
	"./vanilla/wh2_main_hef_tiranoc/mon_rotated.png": "678f",
	"./vanilla/wh2_main_hef_tor_elasor/mon_24.png": "c14b",
	"./vanilla/wh2_main_hef_tor_elasor/mon_256.png": "323a2",
	"./vanilla/wh2_main_hef_tor_elasor/mon_64.png": "39e8",
	"./vanilla/wh2_main_hef_tor_elasor/mon_rotated.png": "4ea7",
	"./vanilla/wh2_main_hef_yvresse/mon_24.png": "da93",
	"./vanilla/wh2_main_hef_yvresse/mon_256.png": "f454",
	"./vanilla/wh2_main_hef_yvresse/mon_64.png": "be10",
	"./vanilla/wh2_main_hef_yvresse/mon_rotated.png": "a1af",
	"./vanilla/wh2_main_lzd_hexoatl/mon_24.png": "ea55",
	"./vanilla/wh2_main_lzd_hexoatl/mon_256.png": "9634",
	"./vanilla/wh2_main_lzd_hexoatl/mon_64.png": "75c3",
	"./vanilla/wh2_main_lzd_hexoatl/mon_rotated.png": "77df",
	"./vanilla/wh2_main_lzd_hexoatl_intervention/mon_24.png": "a951",
	"./vanilla/wh2_main_lzd_hexoatl_intervention/mon_256.png": "cb0b",
	"./vanilla/wh2_main_lzd_hexoatl_intervention/mon_64.png": "5792",
	"./vanilla/wh2_main_lzd_hexoatl_intervention/mon_rotated.png": "899d",
	"./vanilla/wh2_main_lzd_itza/mon_24.png": "000b",
	"./vanilla/wh2_main_lzd_itza/mon_256.png": "c355",
	"./vanilla/wh2_main_lzd_itza/mon_64.png": "a0b1",
	"./vanilla/wh2_main_lzd_itza/mon_rotated.png": "7216",
	"./vanilla/wh2_main_lzd_last_defenders/mon_24.png": "0859",
	"./vanilla/wh2_main_lzd_last_defenders/mon_256.png": "226e",
	"./vanilla/wh2_main_lzd_last_defenders/mon_64.png": "4bed",
	"./vanilla/wh2_main_lzd_last_defenders/mon_rotated.png": "0f53",
	"./vanilla/wh2_main_lzd_lizardmen_rebels/mon_24.png": "6fef",
	"./vanilla/wh2_main_lzd_lizardmen_rebels/mon_256.png": "a909",
	"./vanilla/wh2_main_lzd_lizardmen_rebels/mon_64.png": "61f1",
	"./vanilla/wh2_main_lzd_lizardmen_rebels/mon_rotated.png": "d5f6",
	"./vanilla/wh2_main_lzd_sentinels_of_xeti/mon_24.png": "c2b8",
	"./vanilla/wh2_main_lzd_sentinels_of_xeti/mon_256.png": "7834",
	"./vanilla/wh2_main_lzd_sentinels_of_xeti/mon_64.png": "a137",
	"./vanilla/wh2_main_lzd_sentinels_of_xeti/mon_rotated.png": "bb43",
	"./vanilla/wh2_main_lzd_southern_sentinels/mon_24.png": "c011",
	"./vanilla/wh2_main_lzd_southern_sentinels/mon_256.png": "d364",
	"./vanilla/wh2_main_lzd_southern_sentinels/mon_64.png": "87c9",
	"./vanilla/wh2_main_lzd_southern_sentinels/mon_rotated.png": "66a7",
	"./vanilla/wh2_main_lzd_teotiqua/mon_24.png": "66fc",
	"./vanilla/wh2_main_lzd_teotiqua/mon_256.png": "fce4",
	"./vanilla/wh2_main_lzd_teotiqua/mon_64.png": "c751",
	"./vanilla/wh2_main_lzd_teotiqua/mon_rotated.png": "363e",
	"./vanilla/wh2_main_lzd_tlaqua/mon_24.png": "64b0",
	"./vanilla/wh2_main_lzd_tlaqua/mon_256.png": "335b",
	"./vanilla/wh2_main_lzd_tlaqua/mon_64.png": "ef8b",
	"./vanilla/wh2_main_lzd_tlaqua/mon_rotated.png": "8a1a",
	"./vanilla/wh2_main_lzd_tlaxtlan/mon_24.png": "51ef",
	"./vanilla/wh2_main_lzd_tlaxtlan/mon_256.png": "184f",
	"./vanilla/wh2_main_lzd_tlaxtlan/mon_64.png": "f3ab",
	"./vanilla/wh2_main_lzd_tlaxtlan/mon_rotated.png": "738e",
	"./vanilla/wh2_main_lzd_xlanhuapec/mon_24.png": "488e",
	"./vanilla/wh2_main_lzd_xlanhuapec/mon_256.png": "56db",
	"./vanilla/wh2_main_lzd_xlanhuapec/mon_64.png": "b95c",
	"./vanilla/wh2_main_lzd_xlanhuapec/mon_rotated.png": "24d0",
	"./vanilla/wh2_main_lzd_zlatan/mon_24.png": "59a3",
	"./vanilla/wh2_main_lzd_zlatan/mon_256.png": "65a3",
	"./vanilla/wh2_main_lzd_zlatan/mon_64.png": "5bec",
	"./vanilla/wh2_main_lzd_zlatan/mon_rotated.png": "6f96",
	"./vanilla/wh2_main_nor_aghol/mon_24.png": "3b57",
	"./vanilla/wh2_main_nor_aghol/mon_256.png": "e37e",
	"./vanilla/wh2_main_nor_aghol/mon_64.png": "895c",
	"./vanilla/wh2_main_nor_aghol/mon_rotated.png": "baf1",
	"./vanilla/wh2_main_nor_mung/mon_24.png": "5f7e",
	"./vanilla/wh2_main_nor_mung/mon_256.png": "2252",
	"./vanilla/wh2_main_nor_mung/mon_64.png": "a5f9",
	"./vanilla/wh2_main_nor_mung/mon_rotated.png": "1681",
	"./vanilla/wh2_main_nor_skeggi/mon_24.png": "e9ce",
	"./vanilla/wh2_main_nor_skeggi/mon_256.png": "f513",
	"./vanilla/wh2_main_nor_skeggi/mon_64.png": "f7ea",
	"./vanilla/wh2_main_nor_skeggi/mon_rotated.png": "2c91",
	"./vanilla/wh2_main_nor_warband_of_the_crow/mon_24.png": "59d8",
	"./vanilla/wh2_main_nor_warband_of_the_crow/mon_256.png": "79e4",
	"./vanilla/wh2_main_nor_warband_of_the_crow/mon_64.png": "cca7",
	"./vanilla/wh2_main_nor_warband_of_the_crow/mon_rotated.png": "ca15",
	"./vanilla/wh2_main_nor_warband_of_the_eagle/mon_24.png": "eb4f",
	"./vanilla/wh2_main_nor_warband_of_the_eagle/mon_256.png": "2a30",
	"./vanilla/wh2_main_nor_warband_of_the_eagle/mon_64.png": "3aa6",
	"./vanilla/wh2_main_nor_warband_of_the_eagle/mon_rotated.png": "c779",
	"./vanilla/wh2_main_nor_warband_of_the_hound/mon_24.png": "18ae",
	"./vanilla/wh2_main_nor_warband_of_the_hound/mon_256.png": "6d60",
	"./vanilla/wh2_main_nor_warband_of_the_hound/mon_64.png": "c129",
	"./vanilla/wh2_main_nor_warband_of_the_hound/mon_rotated.png": "f8357",
	"./vanilla/wh2_main_nor_warband_of_the_serpent/mon_24.png": "66c6",
	"./vanilla/wh2_main_nor_warband_of_the_serpent/mon_256.png": "cf25",
	"./vanilla/wh2_main_nor_warband_of_the_serpent/mon_64.png": "42b4",
	"./vanilla/wh2_main_nor_warband_of_the_serpent/mon_rotated.png": "3a96",
	"./vanilla/wh2_main_rogue_abominations/mon_24.png": "5a38",
	"./vanilla/wh2_main_rogue_abominations/mon_256.png": "ae8f",
	"./vanilla/wh2_main_rogue_abominations/mon_64.png": "b618",
	"./vanilla/wh2_main_rogue_abominations/mon_rotated.png": "844d",
	"./vanilla/wh2_main_rogue_beastcatchas/mon_24.png": "19da",
	"./vanilla/wh2_main_rogue_beastcatchas/mon_256.png": "c08e",
	"./vanilla/wh2_main_rogue_beastcatchas/mon_64.png": "bdf8",
	"./vanilla/wh2_main_rogue_beastcatchas/mon_rotated.png": "c417",
	"./vanilla/wh2_main_rogue_bernhoff/mon_24.png": "478e",
	"./vanilla/wh2_main_rogue_bernhoff/mon_256.png": "fe12",
	"./vanilla/wh2_main_rogue_bernhoff/mon_64.png": "7f91",
	"./vanilla/wh2_main_rogue_bernhoff/mon_rotated.png": "c40f",
	"./vanilla/wh2_main_rogue_black_spider/mon_24.png": "a979",
	"./vanilla/wh2_main_rogue_black_spider/mon_256.png": "c8db",
	"./vanilla/wh2_main_rogue_black_spider/mon_64.png": "dbeb",
	"./vanilla/wh2_main_rogue_black_spider/mon_rotated.png": "09c8",
	"./vanilla/wh2_main_rogue_bone_clubbers/mon_24.png": "613b",
	"./vanilla/wh2_main_rogue_bone_clubbers/mon_256.png": "435f",
	"./vanilla/wh2_main_rogue_bone_clubbers/mon_64.png": "f0da",
	"./vanilla/wh2_main_rogue_bone_clubbers/mon_rotated.png": "219d",
	"./vanilla/wh2_main_rogue_celestial_storm/mon_24.png": "4da4",
	"./vanilla/wh2_main_rogue_celestial_storm/mon_256.png": "2bb1",
	"./vanilla/wh2_main_rogue_celestial_storm/mon_64.png": "4f76",
	"./vanilla/wh2_main_rogue_celestial_storm/mon_rotated.png": "caae",
	"./vanilla/wh2_main_rogue_doomseekers/mon_24.png": "56fe",
	"./vanilla/wh2_main_rogue_doomseekers/mon_256.png": "faa2",
	"./vanilla/wh2_main_rogue_doomseekers/mon_64.png": "7b53",
	"./vanilla/wh2_main_rogue_doomseekers/mon_rotated.png": "a3e5",
	"./vanilla/wh2_main_rogue_gerhardt/mon_24.png": "8461",
	"./vanilla/wh2_main_rogue_gerhardt/mon_256.png": "6e4c",
	"./vanilla/wh2_main_rogue_gerhardt/mon_64.png": "017a",
	"./vanilla/wh2_main_rogue_gerhardt/mon_rotated.png": "cb0e",
	"./vanilla/wh2_main_rogue_hung_warband/mon_24.png": "c452",
	"./vanilla/wh2_main_rogue_hung_warband/mon_256.png": "03c3",
	"./vanilla/wh2_main_rogue_hung_warband/mon_64.png": "3edd",
	"./vanilla/wh2_main_rogue_hung_warband/mon_rotated.png": "1c32",
	"./vanilla/wh2_main_rogue_jerrod/mon_24.png": "7f8a",
	"./vanilla/wh2_main_rogue_jerrod/mon_256.png": "ad34",
	"./vanilla/wh2_main_rogue_jerrod/mon_64.png": "ecef",
	"./vanilla/wh2_main_rogue_jerrod/mon_rotated.png": "fede",
	"./vanilla/wh2_main_rogue_kournos/mon_24.png": "ac60",
	"./vanilla/wh2_main_rogue_kournos/mon_256.png": "9a13",
	"./vanilla/wh2_main_rogue_kournos/mon_64.png": "0fc3",
	"./vanilla/wh2_main_rogue_kournos/mon_rotated.png": "b93f",
	"./vanilla/wh2_main_rogue_mengil_manhide/mon_24.png": "3353",
	"./vanilla/wh2_main_rogue_mengil_manhide/mon_256.png": "d913",
	"./vanilla/wh2_main_rogue_mengil_manhide/mon_64.png": "5c21",
	"./vanilla/wh2_main_rogue_mengil_manhide/mon_rotated.png": "a40c",
	"./vanilla/wh2_main_rogue_morrslieb/mon_24.png": "fd70",
	"./vanilla/wh2_main_rogue_morrslieb/mon_256.png": "8265",
	"./vanilla/wh2_main_rogue_morrslieb/mon_64.png": "56be",
	"./vanilla/wh2_main_rogue_morrslieb/mon_rotated.png": "9ce3",
	"./vanilla/wh2_main_rogue_mourkain/mon_24.png": "1e9a",
	"./vanilla/wh2_main_rogue_mourkain/mon_256.png": "3ef7",
	"./vanilla/wh2_main_rogue_mourkain/mon_64.png": "f0b3",
	"./vanilla/wh2_main_rogue_mourkain/mon_rotated.png": "d2ec",
	"./vanilla/wh2_main_rogue_pirates_trantio/mon_24.png": "b98e",
	"./vanilla/wh2_main_rogue_pirates_trantio/mon_256.png": "b653",
	"./vanilla/wh2_main_rogue_pirates_trantio/mon_64.png": "8653",
	"./vanilla/wh2_main_rogue_pirates_trantio/mon_rotated.png": "40e7",
	"./vanilla/wh2_main_rogue_pyrotechnics/mon_24.png": "b0a4",
	"./vanilla/wh2_main_rogue_pyrotechnics/mon_256.png": "8b26",
	"./vanilla/wh2_main_rogue_pyrotechnics/mon_64.png": "fd4c",
	"./vanilla/wh2_main_rogue_pyrotechnics/mon_rotated.png": "621e",
	"./vanilla/wh2_main_rogue_scourge_of_aq/mon_24.png": "eb26",
	"./vanilla/wh2_main_rogue_scourge_of_aq/mon_256.png": "c2b1",
	"./vanilla/wh2_main_rogue_scourge_of_aq/mon_64.png": "909f",
	"./vanilla/wh2_main_rogue_scourge_of_aq/mon_rotated.png": "e431",
	"./vanilla/wh2_main_rogue_stuff_snatchers/mon_24.png": "989f",
	"./vanilla/wh2_main_rogue_stuff_snatchers/mon_256.png": "441a",
	"./vanilla/wh2_main_rogue_stuff_snatchers/mon_64.png": "3d35",
	"./vanilla/wh2_main_rogue_stuff_snatchers/mon_rotated.png": "9188",
	"./vanilla/wh2_main_rogue_tor_elesor/mon_24.png": "c245",
	"./vanilla/wh2_main_rogue_tor_elesor/mon_256.png": "de3d",
	"./vanilla/wh2_main_rogue_tor_elesor/mon_64.png": "887e",
	"./vanilla/wh2_main_rogue_tor_elesor/mon_rotated.png": "2cc2",
	"./vanilla/wh2_main_rogue_troll_skullz/mon_24.png": "ad2e",
	"./vanilla/wh2_main_rogue_troll_skullz/mon_256.png": "3bb4",
	"./vanilla/wh2_main_rogue_troll_skullz/mon_64.png": "2a6cc",
	"./vanilla/wh2_main_rogue_troll_skullz/mon_rotated.png": "767a",
	"./vanilla/wh2_main_rogue_vashnaar/mon_24.png": "8113",
	"./vanilla/wh2_main_rogue_vashnaar/mon_256.png": "f592",
	"./vanilla/wh2_main_rogue_vashnaar/mon_64.png": "8592",
	"./vanilla/wh2_main_rogue_vashnaar/mon_rotated.png": "6080",
	"./vanilla/wh2_main_rogue_wrath_of_nature/mon_24.png": "b9dd",
	"./vanilla/wh2_main_rogue_wrath_of_nature/mon_256.png": "b9b9",
	"./vanilla/wh2_main_rogue_wrath_of_nature/mon_64.png": "cdd2",
	"./vanilla/wh2_main_rogue_wrath_of_nature/mon_rotated.png": "9611",
	"./vanilla/wh2_main_skv_clan_eshin/mon_24.png": "1b91",
	"./vanilla/wh2_main_skv_clan_eshin/mon_256.png": "6e96",
	"./vanilla/wh2_main_skv_clan_eshin/mon_64.png": "b152",
	"./vanilla/wh2_main_skv_clan_eshin/mon_rotated.png": "6552",
	"./vanilla/wh2_main_skv_clan_eshin_separatists/mon_24.png": "9226",
	"./vanilla/wh2_main_skv_clan_eshin_separatists/mon_256.png": "36e1",
	"./vanilla/wh2_main_skv_clan_eshin_separatists/mon_64.png": "c919",
	"./vanilla/wh2_main_skv_clan_eshin_separatists/mon_rotated.png": "c0f3",
	"./vanilla/wh2_main_skv_clan_gnaw/mon_24.png": "3411",
	"./vanilla/wh2_main_skv_clan_gnaw/mon_256.png": "33bd",
	"./vanilla/wh2_main_skv_clan_gnaw/mon_64.png": "ce8e",
	"./vanilla/wh2_main_skv_clan_gnaw/mon_rotated.png": "e969",
	"./vanilla/wh2_main_skv_clan_mordkin/mon_24.png": "ecd9",
	"./vanilla/wh2_main_skv_clan_mordkin/mon_256.png": "2c30f",
	"./vanilla/wh2_main_skv_clan_mordkin/mon_64.png": "dfecc",
	"./vanilla/wh2_main_skv_clan_mordkin/mon_rotated.png": "6300",
	"./vanilla/wh2_main_skv_clan_mors/mon_24.png": "b252",
	"./vanilla/wh2_main_skv_clan_mors/mon_256.png": "3dcc",
	"./vanilla/wh2_main_skv_clan_mors/mon_64.png": "01e4",
	"./vanilla/wh2_main_skv_clan_mors/mon_rotated.png": "5647",
	"./vanilla/wh2_main_skv_clan_mors_intervention/mon_24.png": "e656",
	"./vanilla/wh2_main_skv_clan_mors_intervention/mon_256.png": "2bf0",
	"./vanilla/wh2_main_skv_clan_mors_intervention/mon_64.png": "b8c9",
	"./vanilla/wh2_main_skv_clan_mors_intervention/mon_rotated.png": "ad97",
	"./vanilla/wh2_main_skv_clan_mors_separatists/mon_24.png": "f680",
	"./vanilla/wh2_main_skv_clan_mors_separatists/mon_256.png": "5198",
	"./vanilla/wh2_main_skv_clan_mors_separatists/mon_64.png": "48db",
	"./vanilla/wh2_main_skv_clan_mors_separatists/mon_rotated.png": "d09c",
	"./vanilla/wh2_main_skv_clan_moulder/mon_24.png": "87d16",
	"./vanilla/wh2_main_skv_clan_moulder/mon_256.png": "1bc1",
	"./vanilla/wh2_main_skv_clan_moulder/mon_64.png": "224e",
	"./vanilla/wh2_main_skv_clan_moulder/mon_rotated.png": "241f",
	"./vanilla/wh2_main_skv_clan_pestilens/mon_24.png": "4efa",
	"./vanilla/wh2_main_skv_clan_pestilens/mon_256.png": "57a8",
	"./vanilla/wh2_main_skv_clan_pestilens/mon_64.png": "24ea",
	"./vanilla/wh2_main_skv_clan_pestilens/mon_rotated.png": "9ec6",
	"./vanilla/wh2_main_skv_clan_pestilens_separatists/mon_24.png": "9125",
	"./vanilla/wh2_main_skv_clan_pestilens_separatists/mon_256.png": "578f",
	"./vanilla/wh2_main_skv_clan_pestilens_separatists/mon_64.png": "a925",
	"./vanilla/wh2_main_skv_clan_pestilens_separatists/mon_rotated.png": "4f89",
	"./vanilla/wh2_main_skv_clan_septik/mon_24.png": "3022",
	"./vanilla/wh2_main_skv_clan_septik/mon_256.png": "a6e4",
	"./vanilla/wh2_main_skv_clan_septik/mon_64.png": "03c1",
	"./vanilla/wh2_main_skv_clan_septik/mon_rotated.png": "cdcc",
	"./vanilla/wh2_main_skv_clan_skryre_separatists/mon_24.png": "0222",
	"./vanilla/wh2_main_skv_clan_skryre_separatists/mon_256.png": "8b90",
	"./vanilla/wh2_main_skv_clan_skryre_separatists/mon_64.png": "f229",
	"./vanilla/wh2_main_skv_clan_skryre_separatists/mon_rotated.png": "bea8",
	"./vanilla/wh2_main_skv_clan_skyre/mon_24.png": "9c64",
	"./vanilla/wh2_main_skv_clan_skyre/mon_256.png": "dcae",
	"./vanilla/wh2_main_skv_clan_skyre/mon_64.png": "dd8b",
	"./vanilla/wh2_main_skv_clan_skyre/mon_rotated.png": "bff1",
	"./vanilla/wh2_main_skv_clan_spittel/mon_24.png": "07b6",
	"./vanilla/wh2_main_skv_clan_spittel/mon_256.png": "1590",
	"./vanilla/wh2_main_skv_clan_spittel/mon_64.png": "c207",
	"./vanilla/wh2_main_skv_clan_spittel/mon_rotated.png": "36b9",
	"./vanilla/wh2_main_skv_grey_seer_clan/mon_24.png": "21cd",
	"./vanilla/wh2_main_skv_grey_seer_clan/mon_256.png": "3153",
	"./vanilla/wh2_main_skv_grey_seer_clan/mon_64.png": "0027",
	"./vanilla/wh2_main_skv_grey_seer_clan/mon_rotated.png": "812d",
	"./vanilla/wh2_main_skv_skaven_rebels/mon_24.png": "4b15",
	"./vanilla/wh2_main_skv_skaven_rebels/mon_256.png": "5316",
	"./vanilla/wh2_main_skv_skaven_rebels/mon_64.png": "016e",
	"./vanilla/wh2_main_skv_skaven_rebels/mon_rotated.png": "3a94",
	"./vanilla/wh2_main_skv_unknown_clan_def/mon_24.png": "0602",
	"./vanilla/wh2_main_skv_unknown_clan_def/mon_256.png": "1bdf",
	"./vanilla/wh2_main_skv_unknown_clan_def/mon_64.png": "5962",
	"./vanilla/wh2_main_skv_unknown_clan_def/mon_rotated.png": "5873",
	"./vanilla/wh2_main_skv_unknown_clan_hef/mon_24.png": "0315",
	"./vanilla/wh2_main_skv_unknown_clan_hef/mon_256.png": "db58",
	"./vanilla/wh2_main_skv_unknown_clan_hef/mon_64.png": "6a6e",
	"./vanilla/wh2_main_skv_unknown_clan_hef/mon_rotated.png": "3842",
	"./vanilla/wh2_main_skv_unknown_clan_lzd/mon_24.png": "3f26",
	"./vanilla/wh2_main_skv_unknown_clan_lzd/mon_256.png": "9a5c",
	"./vanilla/wh2_main_skv_unknown_clan_lzd/mon_64.png": "0070",
	"./vanilla/wh2_main_skv_unknown_clan_lzd/mon_rotated.png": "9758",
	"./vanilla/wh2_main_skv_unknown_clan_skv/mon_24.png": "f093",
	"./vanilla/wh2_main_skv_unknown_clan_skv/mon_256.png": "2e09",
	"./vanilla/wh2_main_skv_unknown_clan_skv/mon_64.png": "e7c3",
	"./vanilla/wh2_main_skv_unknown_clan_skv/mon_rotated.png": "06ee",
	"./vanilla/wh2_main_vmp_necrarch_brotherhood/mon_24.png": "f4b0",
	"./vanilla/wh2_main_vmp_necrarch_brotherhood/mon_256.png": "e108",
	"./vanilla/wh2_main_vmp_necrarch_brotherhood/mon_64.png": "1ce1",
	"./vanilla/wh2_main_vmp_necrarch_brotherhood/mon_rotated.png": "4b63",
	"./vanilla/wh2_main_vmp_strygos_empire/mon_24.png": "816a",
	"./vanilla/wh2_main_vmp_strygos_empire/mon_256.png": "90d7",
	"./vanilla/wh2_main_vmp_strygos_empire/mon_64.png": "3c66",
	"./vanilla/wh2_main_vmp_strygos_empire/mon_rotated.png": "7a55",
	"./vanilla/wh2_main_vmp_the_silver_host/mon_24.png": "cfa1",
	"./vanilla/wh2_main_vmp_the_silver_host/mon_256.png": "c2ad",
	"./vanilla/wh2_main_vmp_the_silver_host/mon_64.png": "1710",
	"./vanilla/wh2_main_vmp_the_silver_host/mon_rotated.png": "08a3",
	"./vanilla/wh2_main_vmp_vampire_coast/mon_24.png": "3508",
	"./vanilla/wh2_main_vmp_vampire_coast/mon_256.png": "1c2e",
	"./vanilla/wh2_main_vmp_vampire_coast/mon_64.png": "9190",
	"./vanilla/wh2_main_vmp_vampire_coast/mon_rotated.png": "0388",
	"./vanilla/wh2_main_wef_oreon/mon_24.png": "f70d",
	"./vanilla/wh2_main_wef_oreon/mon_256.png": "5ec2",
	"./vanilla/wh2_main_wef_oreon/mon_64.png": "8208",
	"./vanilla/wh2_main_wef_oreon/mon_rotated.png": "1c32b",
	"./vanilla/wh_dlc03_bst_beastmen/mon_24.png": "1215",
	"./vanilla/wh_dlc03_bst_beastmen/mon_256.png": "b17c",
	"./vanilla/wh_dlc03_bst_beastmen/mon_64.png": "8a38",
	"./vanilla/wh_dlc03_bst_beastmen/mon_rotated.png": "5443",
	"./vanilla/wh_dlc03_bst_beastmen_chaos/mon_24.png": "e7ea",
	"./vanilla/wh_dlc03_bst_beastmen_chaos/mon_256.png": "f762",
	"./vanilla/wh_dlc03_bst_beastmen_chaos/mon_64.png": "5a04",
	"./vanilla/wh_dlc03_bst_beastmen_chaos/mon_rotated.png": "1f71",
	"./vanilla/wh_dlc03_bst_beastmen_jagged_horn/mon_24.png": "7299",
	"./vanilla/wh_dlc03_bst_beastmen_jagged_horn/mon_256.png": "03c6",
	"./vanilla/wh_dlc03_bst_beastmen_jagged_horn/mon_64.png": "f2e5",
	"./vanilla/wh_dlc03_bst_beastmen_jagged_horn/mon_rotated.png": "52e9",
	"./vanilla/wh_dlc03_bst_beastmen_rebels/mon_24.png": "85d2",
	"./vanilla/wh_dlc03_bst_beastmen_rebels/mon_256.png": "627d",
	"./vanilla/wh_dlc03_bst_beastmen_rebels/mon_64.png": "e388",
	"./vanilla/wh_dlc03_bst_beastmen_rebels/mon_rotated.png": "e324",
	"./vanilla/wh_dlc03_bst_beastmen_redhorn/mon_24.png": "c02b",
	"./vanilla/wh_dlc03_bst_beastmen_redhorn/mon_256.png": "f31f",
	"./vanilla/wh_dlc03_bst_beastmen_redhorn/mon_64.png": "7bca",
	"./vanilla/wh_dlc03_bst_beastmen_redhorn/mon_rotated.png": "3d7e6",
	"./vanilla/wh_dlc03_bst_beastmen_ripper_horn/mon_24.png": "f5e8",
	"./vanilla/wh_dlc03_bst_beastmen_ripper_horn/mon_256.png": "1028",
	"./vanilla/wh_dlc03_bst_beastmen_ripper_horn/mon_64.png": "330f",
	"./vanilla/wh_dlc03_bst_beastmen_ripper_horn/mon_rotated.png": "de92",
	"./vanilla/wh_dlc03_bst_beastmen_shadowgor/mon_24.png": "395e",
	"./vanilla/wh_dlc03_bst_beastmen_shadowgor/mon_256.png": "a20f",
	"./vanilla/wh_dlc03_bst_beastmen_shadowgor/mon_64.png": "d829",
	"./vanilla/wh_dlc03_bst_beastmen_shadowgor/mon_rotated.png": "498c",
	"./vanilla/wh_dlc03_bst_beastmen_skrinderkin/mon_24.png": "3c0f",
	"./vanilla/wh_dlc03_bst_beastmen_skrinderkin/mon_256.png": "1301",
	"./vanilla/wh_dlc03_bst_beastmen_skrinderkin/mon_64.png": "dd61",
	"./vanilla/wh_dlc03_bst_beastmen_skrinderkin/mon_rotated.png": "79f1",
	"./vanilla/wh_dlc05_bst_beastmen_morghur_herd/mon_24.png": "21a6",
	"./vanilla/wh_dlc05_bst_beastmen_morghur_herd/mon_256.png": "1ad4",
	"./vanilla/wh_dlc05_bst_beastmen_morghur_herd/mon_64.png": "ffa4",
	"./vanilla/wh_dlc05_bst_beastmen_morghur_herd/mon_rotated.png": "eb2a",
	"./vanilla/wh_dlc05_wef_argwylon/mon_24.png": "7bab",
	"./vanilla/wh_dlc05_wef_argwylon/mon_256.png": "40fb",
	"./vanilla/wh_dlc05_wef_argwylon/mon_64.png": "c343",
	"./vanilla/wh_dlc05_wef_argwylon/mon_rotated.png": "8783",
	"./vanilla/wh_dlc05_wef_torgovann/mon_24.png": "b360",
	"./vanilla/wh_dlc05_wef_torgovann/mon_256.png": "5a70",
	"./vanilla/wh_dlc05_wef_torgovann/mon_64.png": "06c53",
	"./vanilla/wh_dlc05_wef_torgovann/mon_rotated.png": "6b31",
	"./vanilla/wh_dlc05_wef_wood_elves/mon_24.png": "3f80",
	"./vanilla/wh_dlc05_wef_wood_elves/mon_256.png": "c6b9",
	"./vanilla/wh_dlc05_wef_wood_elves/mon_64.png": "aa8c",
	"./vanilla/wh_dlc05_wef_wood_elves/mon_rotated.png": "d4d1",
	"./vanilla/wh_dlc05_wef_wood_elves_rebels/mon_24.png": "5afe",
	"./vanilla/wh_dlc05_wef_wood_elves_rebels/mon_256.png": "5a4f",
	"./vanilla/wh_dlc05_wef_wood_elves_rebels/mon_64.png": "9699",
	"./vanilla/wh_dlc05_wef_wood_elves_rebels/mon_rotated.png": "2f75",
	"./vanilla/wh_dlc05_wef_wydrioth/mon_24.png": "3959",
	"./vanilla/wh_dlc05_wef_wydrioth/mon_256.png": "705b",
	"./vanilla/wh_dlc05_wef_wydrioth/mon_64.png": "7189",
	"./vanilla/wh_dlc05_wef_wydrioth/mon_rotated.png": "b08e",
	"./vanilla/wh_dlc06_dwf_clan_angrund/mon_24.png": "12a8",
	"./vanilla/wh_dlc06_dwf_clan_angrund/mon_256.png": "6de9",
	"./vanilla/wh_dlc06_dwf_clan_angrund/mon_64.png": "5f7a",
	"./vanilla/wh_dlc06_dwf_clan_angrund/mon_rotated.png": "1068",
	"./vanilla/wh_dlc06_grn_crooked_moon_rebels/mon_24.png": "6029",
	"./vanilla/wh_dlc06_grn_crooked_moon_rebels/mon_256.png": "adc0",
	"./vanilla/wh_dlc06_grn_crooked_moon_rebels/mon_64.png": "0ea1",
	"./vanilla/wh_dlc06_grn_crooked_moon_rebels/mon_rotated.png": "008d",
	"./vanilla/wh_dlc07_vmp_von_carstein/mon_24.png": "dddb",
	"./vanilla/wh_dlc07_vmp_von_carstein/mon_256.png": "223a",
	"./vanilla/wh_dlc07_vmp_von_carstein/mon_64.png": "0d98",
	"./vanilla/wh_dlc07_vmp_von_carstein/mon_rotated.png": "1305",
	"./vanilla/wh_dlc08_chs_challenger_of_the_crow/mon_24.png": "4df8",
	"./vanilla/wh_dlc08_chs_challenger_of_the_crow/mon_256.png": "268b",
	"./vanilla/wh_dlc08_chs_challenger_of_the_crow/mon_64.png": "7b85",
	"./vanilla/wh_dlc08_chs_challenger_of_the_crow/mon_rotated.png": "9a16",
	"./vanilla/wh_dlc08_chs_challenger_of_the_eagle/mon_24.png": "f472",
	"./vanilla/wh_dlc08_chs_challenger_of_the_eagle/mon_256.png": "44d6",
	"./vanilla/wh_dlc08_chs_challenger_of_the_eagle/mon_64.png": "9ccb",
	"./vanilla/wh_dlc08_chs_challenger_of_the_eagle/mon_rotated.png": "e92a",
	"./vanilla/wh_dlc08_chs_challenger_of_the_hound/mon_24.png": "8490",
	"./vanilla/wh_dlc08_chs_challenger_of_the_hound/mon_256.png": "bbc9",
	"./vanilla/wh_dlc08_chs_challenger_of_the_hound/mon_64.png": "7614",
	"./vanilla/wh_dlc08_chs_challenger_of_the_hound/mon_rotated.png": "f15b",
	"./vanilla/wh_dlc08_chs_challenger_of_the_serpent/mon_24.png": "afba",
	"./vanilla/wh_dlc08_chs_challenger_of_the_serpent/mon_256.png": "0464",
	"./vanilla/wh_dlc08_chs_challenger_of_the_serpent/mon_64.png": "ed62",
	"./vanilla/wh_dlc08_chs_challenger_of_the_serpent/mon_rotated.png": "a0d2",
	"./vanilla/wh_dlc08_nor_goromadny/mon_24.png": "db5c",
	"./vanilla/wh_dlc08_nor_goromadny/mon_256.png": "4c54",
	"./vanilla/wh_dlc08_nor_goromadny/mon_64.png": "7c90",
	"./vanilla/wh_dlc08_nor_goromadny/mon_rotated.png": "5438",
	"./vanilla/wh_dlc08_nor_helspire/mon_24.png": "5ee4",
	"./vanilla/wh_dlc08_nor_helspire/mon_256.png": "49b9",
	"./vanilla/wh_dlc08_nor_helspire/mon_64.png": "df32",
	"./vanilla/wh_dlc08_nor_helspire/mon_rotated.png": "fed5",
	"./vanilla/wh_dlc08_nor_naglfarlings/mon_24.png": "bb2d",
	"./vanilla/wh_dlc08_nor_naglfarlings/mon_256.png": "ac51",
	"./vanilla/wh_dlc08_nor_naglfarlings/mon_64.png": "5794",
	"./vanilla/wh_dlc08_nor_naglfarlings/mon_rotated.png": "e056",
	"./vanilla/wh_dlc08_nor_norsca/mon_24.png": "0f3c",
	"./vanilla/wh_dlc08_nor_norsca/mon_256.png": "7fd0",
	"./vanilla/wh_dlc08_nor_norsca/mon_64.png": "9696",
	"./vanilla/wh_dlc08_nor_norsca/mon_rotated.png": "151c",
	"./vanilla/wh_dlc08_nor_vanaheimlings/mon_24.png": "d738",
	"./vanilla/wh_dlc08_nor_vanaheimlings/mon_256.png": "bbd0",
	"./vanilla/wh_dlc08_nor_vanaheimlings/mon_64.png": "b7e5",
	"./vanilla/wh_dlc08_nor_vanaheimlings/mon_rotated.png": "aa88",
	"./vanilla/wh_dlc08_nor_wintertooth/mon_24.png": "84ea",
	"./vanilla/wh_dlc08_nor_wintertooth/mon_256.png": "ffa48",
	"./vanilla/wh_dlc08_nor_wintertooth/mon_64.png": "4732",
	"./vanilla/wh_dlc08_nor_wintertooth/mon_rotated.png": "90cb",
	"./vanilla/wh_dlc12_grn_leaf_cutterz/mon_24.png": "0a34",
	"./vanilla/wh_dlc12_grn_leaf_cutterz/mon_256.png": "16a8",
	"./vanilla/wh_dlc12_grn_leaf_cutterz/mon_64.png": "43f0",
	"./vanilla/wh_dlc12_grn_leaf_cutterz/mon_rotated.png": "e035",
	"./vanilla/wh_dlc14_brt_chevaliers_de_lyonesse/mon_24.png": "d7c0",
	"./vanilla/wh_dlc14_brt_chevaliers_de_lyonesse/mon_256.png": "f230",
	"./vanilla/wh_dlc14_brt_chevaliers_de_lyonesse/mon_64.png": "b867",
	"./vanilla/wh_dlc14_brt_chevaliers_de_lyonesse/mon_rotated.png": "ad6f",
	"./vanilla/wh_main_brt_artois/mon_24.png": "0443",
	"./vanilla/wh_main_brt_artois/mon_256.png": "84a3",
	"./vanilla/wh_main_brt_artois/mon_64.png": "b0bc5",
	"./vanilla/wh_main_brt_artois/mon_rotated.png": "ddb9",
	"./vanilla/wh_main_brt_bastonne/mon_24.png": "4fab",
	"./vanilla/wh_main_brt_bastonne/mon_256.png": "7e5d",
	"./vanilla/wh_main_brt_bastonne/mon_64.png": "11094",
	"./vanilla/wh_main_brt_bastonne/mon_rotated.png": "5b6b",
	"./vanilla/wh_main_brt_bordeleaux/mon_24.png": "6805",
	"./vanilla/wh_main_brt_bordeleaux/mon_256.png": "4811",
	"./vanilla/wh_main_brt_bordeleaux/mon_64.png": "04e4",
	"./vanilla/wh_main_brt_bordeleaux/mon_rotated.png": "aaf4",
	"./vanilla/wh_main_brt_bretonnia/mon_24.png": "5351",
	"./vanilla/wh_main_brt_bretonnia/mon_256.png": "820d",
	"./vanilla/wh_main_brt_bretonnia/mon_64.png": "c216",
	"./vanilla/wh_main_brt_bretonnia/mon_rotated.png": "f97e",
	"./vanilla/wh_main_brt_bretonnia_rebels/mon_24.png": "6671",
	"./vanilla/wh_main_brt_bretonnia_rebels/mon_256.png": "3876",
	"./vanilla/wh_main_brt_bretonnia_rebels/mon_64.png": "44e1",
	"./vanilla/wh_main_brt_bretonnia_rebels/mon_rotated.png": "e3e2",
	"./vanilla/wh_main_brt_carcassonne/mon_24.png": "7624",
	"./vanilla/wh_main_brt_carcassonne/mon_256.png": "2a92e",
	"./vanilla/wh_main_brt_carcassonne/mon_64.png": "56af",
	"./vanilla/wh_main_brt_carcassonne/mon_rotated.png": "9a8a",
	"./vanilla/wh_main_brt_lyonesse/mon_24.png": "319d",
	"./vanilla/wh_main_brt_lyonesse/mon_256.png": "c029",
	"./vanilla/wh_main_brt_lyonesse/mon_64.png": "d7b88",
	"./vanilla/wh_main_brt_lyonesse/mon_rotated.png": "bd1b",
	"./vanilla/wh_main_brt_parravon/mon_24.png": "5f5f",
	"./vanilla/wh_main_brt_parravon/mon_256.png": "1b2e",
	"./vanilla/wh_main_brt_parravon/mon_64.png": "e8e4",
	"./vanilla/wh_main_brt_parravon/mon_rotated.png": "56bc",
	"./vanilla/wh_main_chs_chaos/mon_24.png": "bda9",
	"./vanilla/wh_main_chs_chaos/mon_256.png": "9cbe",
	"./vanilla/wh_main_chs_chaos/mon_64.png": "7056",
	"./vanilla/wh_main_chs_chaos/mon_rotated.png": "9e42",
	"./vanilla/wh_main_chs_chaos_rebels/mon_24.png": "2e7a",
	"./vanilla/wh_main_chs_chaos_rebels/mon_256.png": "92ac",
	"./vanilla/wh_main_chs_chaos_rebels/mon_64.png": "fa9e",
	"./vanilla/wh_main_chs_chaos_rebels/mon_rotated.png": "1893",
	"./vanilla/wh_main_chs_chaos_separatists/mon_24.png": "0793",
	"./vanilla/wh_main_chs_chaos_separatists/mon_256.png": "930a",
	"./vanilla/wh_main_chs_chaos_separatists/mon_64.png": "d3d3",
	"./vanilla/wh_main_chs_chaos_separatists/mon_rotated.png": "7b3e",
	"./vanilla/wh_main_dwf_barak_varr/mon_24.png": "abde",
	"./vanilla/wh_main_dwf_barak_varr/mon_256.png": "a0b0",
	"./vanilla/wh_main_dwf_barak_varr/mon_64.png": "4b54",
	"./vanilla/wh_main_dwf_barak_varr/mon_rotated.png": "6603",
	"./vanilla/wh_main_dwf_dwarf_rebels/mon_24.png": "62e9",
	"./vanilla/wh_main_dwf_dwarf_rebels/mon_256.png": "2911",
	"./vanilla/wh_main_dwf_dwarf_rebels/mon_64.png": "52399",
	"./vanilla/wh_main_dwf_dwarf_rebels/mon_rotated.png": "9549",
	"./vanilla/wh_main_dwf_dwarfs/mon_24.png": "1a34",
	"./vanilla/wh_main_dwf_dwarfs/mon_256.png": "d4ff",
	"./vanilla/wh_main_dwf_dwarfs/mon_64.png": "d8bc",
	"./vanilla/wh_main_dwf_dwarfs/mon_rotated.png": "9e3f",
	"./vanilla/wh_main_dwf_dwarfs_rebels/mon_24.png": "76ea",
	"./vanilla/wh_main_dwf_dwarfs_rebels/mon_256.png": "c38b",
	"./vanilla/wh_main_dwf_dwarfs_rebels/mon_64.png": "1ab2",
	"./vanilla/wh_main_dwf_dwarfs_rebels/mon_rotated.png": "f76c",
	"./vanilla/wh_main_dwf_karak_azul/mon_24.png": "5b8c",
	"./vanilla/wh_main_dwf_karak_azul/mon_256.png": "f885",
	"./vanilla/wh_main_dwf_karak_azul/mon_64.png": "d143",
	"./vanilla/wh_main_dwf_karak_azul/mon_rotated.png": "e46d",
	"./vanilla/wh_main_dwf_karak_hirn/mon_24.png": "9dbe",
	"./vanilla/wh_main_dwf_karak_hirn/mon_256.png": "f397",
	"./vanilla/wh_main_dwf_karak_hirn/mon_64.png": "cf98",
	"./vanilla/wh_main_dwf_karak_hirn/mon_rotated.png": "3219",
	"./vanilla/wh_main_dwf_karak_izor/mon_24.png": "0730",
	"./vanilla/wh_main_dwf_karak_izor/mon_256.png": "6a4d",
	"./vanilla/wh_main_dwf_karak_izor/mon_64.png": "ebdb",
	"./vanilla/wh_main_dwf_karak_izor/mon_rotated.png": "d5b7",
	"./vanilla/wh_main_dwf_karak_kadrin/mon_24.png": "b453",
	"./vanilla/wh_main_dwf_karak_kadrin/mon_256.png": "dd0c",
	"./vanilla/wh_main_dwf_karak_kadrin/mon_64.png": "af69",
	"./vanilla/wh_main_dwf_karak_kadrin/mon_rotated.png": "7de2",
	"./vanilla/wh_main_dwf_karak_norn/mon_24.png": "02b2",
	"./vanilla/wh_main_dwf_karak_norn/mon_256.png": "dbe6",
	"./vanilla/wh_main_dwf_karak_norn/mon_64.png": "d0da",
	"./vanilla/wh_main_dwf_karak_norn/mon_rotated.png": "aa38",
	"./vanilla/wh_main_dwf_karak_ziflin/mon_24.png": "e576",
	"./vanilla/wh_main_dwf_karak_ziflin/mon_256.png": "9ec3",
	"./vanilla/wh_main_dwf_karak_ziflin/mon_64.png": "58f8",
	"./vanilla/wh_main_dwf_karak_ziflin/mon_rotated.png": "d854",
	"./vanilla/wh_main_dwf_kraka_drak/mon_24.png": "ce5c",
	"./vanilla/wh_main_dwf_kraka_drak/mon_256.png": "6df5",
	"./vanilla/wh_main_dwf_kraka_drak/mon_64.png": "e49b",
	"./vanilla/wh_main_dwf_kraka_drak/mon_rotated.png": "52ee",
	"./vanilla/wh_main_dwf_zhufbar/mon_24.png": "fd82",
	"./vanilla/wh_main_dwf_zhufbar/mon_256.png": "a7d8",
	"./vanilla/wh_main_dwf_zhufbar/mon_64.png": "88fa",
	"./vanilla/wh_main_dwf_zhufbar/mon_rotated.png": "a925d",
	"./vanilla/wh_main_emp_averland/mon_24.png": "11ea",
	"./vanilla/wh_main_emp_averland/mon_256.png": "70d3",
	"./vanilla/wh_main_emp_averland/mon_64.png": "00bc",
	"./vanilla/wh_main_emp_averland/mon_rotated.png": "14aa",
	"./vanilla/wh_main_emp_empire/mon_24.png": "2ec6",
	"./vanilla/wh_main_emp_empire/mon_256.png": "4b28",
	"./vanilla/wh_main_emp_empire/mon_64.png": "9764",
	"./vanilla/wh_main_emp_empire/mon_rotated.png": "71e1",
	"./vanilla/wh_main_emp_empire_rebels/mon_24.png": "5195",
	"./vanilla/wh_main_emp_empire_rebels/mon_256.png": "af88",
	"./vanilla/wh_main_emp_empire_rebels/mon_64.png": "1be0",
	"./vanilla/wh_main_emp_empire_rebels/mon_rotated.png": "eb56",
	"./vanilla/wh_main_emp_empire_separatists/mon_24.png": "5af2",
	"./vanilla/wh_main_emp_empire_separatists/mon_256.png": "bd13",
	"./vanilla/wh_main_emp_empire_separatists/mon_64.png": "bbef",
	"./vanilla/wh_main_emp_empire_separatists/mon_rotated.png": "d370",
	"./vanilla/wh_main_emp_hochland/mon_24.png": "24fd",
	"./vanilla/wh_main_emp_hochland/mon_256.png": "c039b",
	"./vanilla/wh_main_emp_hochland/mon_64.png": "a78b",
	"./vanilla/wh_main_emp_hochland/mon_rotated.png": "07e7",
	"./vanilla/wh_main_emp_marienburg/mon_24.png": "50b8",
	"./vanilla/wh_main_emp_marienburg/mon_256.png": "acc8",
	"./vanilla/wh_main_emp_marienburg/mon_64.png": "05a7",
	"./vanilla/wh_main_emp_marienburg/mon_rotated.png": "e370",
	"./vanilla/wh_main_emp_marienburg_rebels/mon_24.png": "37db",
	"./vanilla/wh_main_emp_marienburg_rebels/mon_256.png": "8199",
	"./vanilla/wh_main_emp_marienburg_rebels/mon_64.png": "c4e6",
	"./vanilla/wh_main_emp_marienburg_rebels/mon_rotated.png": "d9ac",
	"./vanilla/wh_main_emp_middenland/mon_24.png": "f421",
	"./vanilla/wh_main_emp_middenland/mon_256.png": "e672",
	"./vanilla/wh_main_emp_middenland/mon_64.png": "52d3",
	"./vanilla/wh_main_emp_middenland/mon_rotated.png": "c491",
	"./vanilla/wh_main_emp_nordland/mon_24.png": "a478",
	"./vanilla/wh_main_emp_nordland/mon_256.png": "3642",
	"./vanilla/wh_main_emp_nordland/mon_64.png": "d5cf",
	"./vanilla/wh_main_emp_nordland/mon_rotated.png": "f611",
	"./vanilla/wh_main_emp_ostermark/mon_24.png": "e1a2",
	"./vanilla/wh_main_emp_ostermark/mon_256.png": "108e",
	"./vanilla/wh_main_emp_ostermark/mon_64.png": "fb93",
	"./vanilla/wh_main_emp_ostermark/mon_rotated.png": "68f9",
	"./vanilla/wh_main_emp_ostland/mon_24.png": "830e",
	"./vanilla/wh_main_emp_ostland/mon_256.png": "910c",
	"./vanilla/wh_main_emp_ostland/mon_64.png": "9661",
	"./vanilla/wh_main_emp_ostland/mon_rotated.png": "7e40",
	"./vanilla/wh_main_emp_stirland/mon_24.png": "8ff0",
	"./vanilla/wh_main_emp_stirland/mon_256.png": "d2aa",
	"./vanilla/wh_main_emp_stirland/mon_64.png": "7025",
	"./vanilla/wh_main_emp_stirland/mon_rotated.png": "e74a",
	"./vanilla/wh_main_emp_talabecland/mon_24.png": "a67f",
	"./vanilla/wh_main_emp_talabecland/mon_256.png": "e452",
	"./vanilla/wh_main_emp_talabecland/mon_64.png": "7739",
	"./vanilla/wh_main_emp_talabecland/mon_rotated.png": "2132",
	"./vanilla/wh_main_emp_wissenland/mon_24.png": "60c7",
	"./vanilla/wh_main_emp_wissenland/mon_256.png": "5c5d",
	"./vanilla/wh_main_emp_wissenland/mon_64.png": "a038",
	"./vanilla/wh_main_emp_wissenland/mon_rotated.png": "22b6",
	"./vanilla/wh_main_grn_black_venom/mon_24.png": "3e79",
	"./vanilla/wh_main_grn_black_venom/mon_256.png": "c426",
	"./vanilla/wh_main_grn_black_venom/mon_64.png": "584f",
	"./vanilla/wh_main_grn_black_venom/mon_rotated.png": "847b",
	"./vanilla/wh_main_grn_bloody_spearz/mon_24.png": "7832",
	"./vanilla/wh_main_grn_bloody_spearz/mon_256.png": "d787",
	"./vanilla/wh_main_grn_bloody_spearz/mon_64.png": "7736",
	"./vanilla/wh_main_grn_bloody_spearz/mon_rotated.png": "90fa",
	"./vanilla/wh_main_grn_broken_nose/mon_24.png": "45cc",
	"./vanilla/wh_main_grn_broken_nose/mon_256.png": "5d8a",
	"./vanilla/wh_main_grn_broken_nose/mon_64.png": "fa1e",
	"./vanilla/wh_main_grn_broken_nose/mon_rotated.png": "d7bc",
	"./vanilla/wh_main_grn_crooked_moon/mon_24.png": "2e84",
	"./vanilla/wh_main_grn_crooked_moon/mon_256.png": "ee0e",
	"./vanilla/wh_main_grn_crooked_moon/mon_64.png": "7bff",
	"./vanilla/wh_main_grn_crooked_moon/mon_rotated.png": "9319",
	"./vanilla/wh_main_grn_greenskins/mon_24.png": "95fb",
	"./vanilla/wh_main_grn_greenskins/mon_256.png": "5b16",
	"./vanilla/wh_main_grn_greenskins/mon_64.png": "c03a",
	"./vanilla/wh_main_grn_greenskins/mon_rotated.png": "90bb",
	"./vanilla/wh_main_grn_greenskins_rebels/mon_24.png": "24f8",
	"./vanilla/wh_main_grn_greenskins_rebels/mon_256.png": "1101",
	"./vanilla/wh_main_grn_greenskins_rebels/mon_64.png": "0731",
	"./vanilla/wh_main_grn_greenskins_rebels/mon_rotated.png": "8ee2",
	"./vanilla/wh_main_grn_necksnappers/mon_24.png": "7a68",
	"./vanilla/wh_main_grn_necksnappers/mon_256.png": "36a8",
	"./vanilla/wh_main_grn_necksnappers/mon_64.png": "d46f",
	"./vanilla/wh_main_grn_necksnappers/mon_rotated.png": "c4cf",
	"./vanilla/wh_main_grn_orcs_of_the_bloody_hand/mon_24.png": "33d7",
	"./vanilla/wh_main_grn_orcs_of_the_bloody_hand/mon_256.png": "ce51",
	"./vanilla/wh_main_grn_orcs_of_the_bloody_hand/mon_64.png": "de5b",
	"./vanilla/wh_main_grn_orcs_of_the_bloody_hand/mon_rotated.png": "ca8d",
	"./vanilla/wh_main_grn_red_eye/mon_24.png": "3f88",
	"./vanilla/wh_main_grn_red_eye/mon_256.png": "6386",
	"./vanilla/wh_main_grn_red_eye/mon_64.png": "97e1",
	"./vanilla/wh_main_grn_red_eye/mon_rotated.png": "4910",
	"./vanilla/wh_main_grn_red_fangs/mon_24.png": "ed50",
	"./vanilla/wh_main_grn_red_fangs/mon_256.png": "f670",
	"./vanilla/wh_main_grn_red_fangs/mon_64.png": "03b0",
	"./vanilla/wh_main_grn_red_fangs/mon_rotated.png": "ffee",
	"./vanilla/wh_main_grn_scabby_eye/mon_24.png": "50f7",
	"./vanilla/wh_main_grn_scabby_eye/mon_256.png": "c64e",
	"./vanilla/wh_main_grn_scabby_eye/mon_64.png": "5014",
	"./vanilla/wh_main_grn_scabby_eye/mon_rotated.png": "c56f",
	"./vanilla/wh_main_grn_skull-takerz/mon_24.png": "43f2",
	"./vanilla/wh_main_grn_skull-takerz/mon_256.png": "068e",
	"./vanilla/wh_main_grn_skull-takerz/mon_64.png": "ccd6",
	"./vanilla/wh_main_grn_skull-takerz/mon_rotated.png": "ee04",
	"./vanilla/wh_main_grn_skullsmasherz/mon_24.png": "34aa",
	"./vanilla/wh_main_grn_skullsmasherz/mon_256.png": "2b07",
	"./vanilla/wh_main_grn_skullsmasherz/mon_64.png": "7cb9",
	"./vanilla/wh_main_grn_skullsmasherz/mon_rotated.png": "5556",
	"./vanilla/wh_main_grn_teef_snatchaz/mon_24.png": "eb1a",
	"./vanilla/wh_main_grn_teef_snatchaz/mon_256.png": "a133",
	"./vanilla/wh_main_grn_teef_snatchaz/mon_64.png": "4edd",
	"./vanilla/wh_main_grn_teef_snatchaz/mon_rotated.png": "eeb1",
	"./vanilla/wh_main_grn_top_knotz/mon_24.png": "feb2",
	"./vanilla/wh_main_grn_top_knotz/mon_256.png": "850d",
	"./vanilla/wh_main_grn_top_knotz/mon_64.png": "f931",
	"./vanilla/wh_main_grn_top_knotz/mon_rotated.png": "4e0f",
	"./vanilla/wh_main_ksl_kislev/mon_24.png": "fdaa",
	"./vanilla/wh_main_ksl_kislev/mon_256.png": "d35f",
	"./vanilla/wh_main_ksl_kislev/mon_64.png": "1abf",
	"./vanilla/wh_main_ksl_kislev/mon_rotated.png": "3b51",
	"./vanilla/wh_main_ksl_kislev_rebels/mon_24.png": "aeed",
	"./vanilla/wh_main_ksl_kislev_rebels/mon_256.png": "adc4",
	"./vanilla/wh_main_ksl_kislev_rebels/mon_64.png": "e225",
	"./vanilla/wh_main_ksl_kislev_rebels/mon_rotated.png": "8f7d",
	"./vanilla/wh_main_nor_aesling/mon_24.png": "6595",
	"./vanilla/wh_main_nor_aesling/mon_256.png": "4836",
	"./vanilla/wh_main_nor_aesling/mon_64.png": "44f0",
	"./vanilla/wh_main_nor_aesling/mon_rotated.png": "3b19",
	"./vanilla/wh_main_nor_baersonling/mon_24.png": "f0df",
	"./vanilla/wh_main_nor_baersonling/mon_256.png": "c9c4",
	"./vanilla/wh_main_nor_baersonling/mon_64.png": "15d7",
	"./vanilla/wh_main_nor_baersonling/mon_rotated.png": "85ae",
	"./vanilla/wh_main_nor_bjornling/mon_24.png": "c7f1",
	"./vanilla/wh_main_nor_bjornling/mon_256.png": "8706",
	"./vanilla/wh_main_nor_bjornling/mon_64.png": "4433",
	"./vanilla/wh_main_nor_bjornling/mon_rotated.png": "9675",
	"./vanilla/wh_main_nor_graeling/mon_24.png": "a453",
	"./vanilla/wh_main_nor_graeling/mon_256.png": "b6a6",
	"./vanilla/wh_main_nor_graeling/mon_64.png": "5ecd",
	"./vanilla/wh_main_nor_graeling/mon_rotated.png": "ef09",
	"./vanilla/wh_main_nor_norsca_rebels/mon_24.png": "26ec",
	"./vanilla/wh_main_nor_norsca_rebels/mon_256.png": "43e3",
	"./vanilla/wh_main_nor_norsca_rebels/mon_64.png": "6f55",
	"./vanilla/wh_main_nor_norsca_rebels/mon_rotated.png": "75a85",
	"./vanilla/wh_main_nor_sarl/mon_24.png": "9b39",
	"./vanilla/wh_main_nor_sarl/mon_256.png": "f340",
	"./vanilla/wh_main_nor_sarl/mon_64.png": "4ebb",
	"./vanilla/wh_main_nor_sarl/mon_rotated.png": "041e",
	"./vanilla/wh_main_nor_skaeling/mon_24.png": "051b",
	"./vanilla/wh_main_nor_skaeling/mon_256.png": "b324",
	"./vanilla/wh_main_nor_skaeling/mon_64.png": "5dab",
	"./vanilla/wh_main_nor_skaeling/mon_rotated.png": "257d",
	"./vanilla/wh_main_nor_varg/mon_24.png": "8209",
	"./vanilla/wh_main_nor_varg/mon_256.png": "214e",
	"./vanilla/wh_main_nor_varg/mon_64.png": "0dec",
	"./vanilla/wh_main_nor_varg/mon_rotated.png": "829b",
	"./vanilla/wh_main_teb_border_princes/mon_24.png": "cb54",
	"./vanilla/wh_main_teb_border_princes/mon_256.png": "75d0",
	"./vanilla/wh_main_teb_border_princes/mon_64.png": "f8cf",
	"./vanilla/wh_main_teb_border_princes/mon_rotated.png": "caed",
	"./vanilla/wh_main_teb_border_princes_rebels/mon_24.png": "84fa",
	"./vanilla/wh_main_teb_border_princes_rebels/mon_256.png": "f389",
	"./vanilla/wh_main_teb_border_princes_rebels/mon_64.png": "f24e",
	"./vanilla/wh_main_teb_border_princes_rebels/mon_rotated.png": "3388",
	"./vanilla/wh_main_teb_estalia/mon_24.png": "6d02",
	"./vanilla/wh_main_teb_estalia/mon_256.png": "caf5",
	"./vanilla/wh_main_teb_estalia/mon_64.png": "fd66",
	"./vanilla/wh_main_teb_estalia/mon_rotated.png": "6478",
	"./vanilla/wh_main_teb_estalia_rebels/mon_24.png": "ca43",
	"./vanilla/wh_main_teb_estalia_rebels/mon_256.png": "2b98",
	"./vanilla/wh_main_teb_estalia_rebels/mon_64.png": "e17a",
	"./vanilla/wh_main_teb_estalia_rebels/mon_rotated.png": "39b3",
	"./vanilla/wh_main_teb_tilea/mon_24.png": "8ee23",
	"./vanilla/wh_main_teb_tilea/mon_256.png": "c149",
	"./vanilla/wh_main_teb_tilea/mon_64.png": "3102",
	"./vanilla/wh_main_teb_tilea/mon_rotated.png": "5f81",
	"./vanilla/wh_main_teb_tilea_rebels/mon_24.png": "3e72",
	"./vanilla/wh_main_teb_tilea_rebels/mon_256.png": "d1f3",
	"./vanilla/wh_main_teb_tilea_rebels/mon_64.png": "7888",
	"./vanilla/wh_main_teb_tilea_rebels/mon_rotated.png": "2e98",
	"./vanilla/wh_main_vmp_mousillon/mon_24.png": "5cc8",
	"./vanilla/wh_main_vmp_mousillon/mon_256.png": "0577",
	"./vanilla/wh_main_vmp_mousillon/mon_64.png": "deac",
	"./vanilla/wh_main_vmp_mousillon/mon_rotated.png": "7116",
	"./vanilla/wh_main_vmp_rival_sylvanian_vamps/mon_24.png": "7b3b",
	"./vanilla/wh_main_vmp_rival_sylvanian_vamps/mon_256.png": "e241",
	"./vanilla/wh_main_vmp_rival_sylvanian_vamps/mon_64.png": "7bcf",
	"./vanilla/wh_main_vmp_rival_sylvanian_vamps/mon_rotated.png": "7723",
	"./vanilla/wh_main_vmp_vampire_counts/mon_24.png": "3bc3",
	"./vanilla/wh_main_vmp_vampire_counts/mon_256.png": "05b7",
	"./vanilla/wh_main_vmp_vampire_counts/mon_64.png": "14af",
	"./vanilla/wh_main_vmp_vampire_counts/mon_rotated.png": "8c20",
	"./vanilla/wh_main_vmp_vampire_rebels/mon_24.png": "6175",
	"./vanilla/wh_main_vmp_vampire_rebels/mon_256.png": "fd77",
	"./vanilla/wh_main_vmp_vampire_rebels/mon_64.png": "41cc",
	"./vanilla/wh_main_vmp_vampire_rebels/mon_rotated.png": "fd6b",
	"./vanilla/wh_main_vmp_waldenhof/mon_24.png": "1606",
	"./vanilla/wh_main_vmp_waldenhof/mon_256.png": "9e63",
	"./vanilla/wh_main_vmp_waldenhof/mon_64.png": "dab0",
	"./vanilla/wh_main_vmp_waldenhof/mon_rotated.png": "1325"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e51";